import React from 'react';
import Image from '../components/image';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLayerGroup, faDatabase, faTag, faAngleDoubleDown, faAngleDoubleUp } from "@fortawesome/free-solid-svg-icons";
// import { faClock as regularClock } from "@fortawesome/fontawesome-free-regular";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
// import Form from 'react-bootstrap/Form';
// import Dropdown from 'react-bootstrap/Dropdown';
// import InputGroup from 'react-bootstrap/InputGroup';
import Select, { components } from 'react-select';
import $ from 'jquery';
import { colMetricList, metricClassMapping, timeRange } from './metric_utils/constants';
// import DropdownTreeSelect from "react-dropdown-tree-select";
// import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from 'moment';
// import Modal from "react-bootstrap/Modal";
import { getMetricsMetadata, postToggleAction, getScheduledInfo } from '../utils/metricEventHandling';
import { toastObj } from '../utils/common_utils';
import Toast from 'react-bootstrap/Toast';
// import RcTooltip from 'rc-tooltip';
// import { sortData } from './metric_utils/common_utils'
// import { Formik, ErrorMessage } from 'formik';
// import * as yup from 'yup';
import BulkSchedule from './components/bulkSchedules';
import IntegrationToggle from './components/integrationToggles';
import DatasetToggle from './components/datasetToggles';
import AttributeToggle from './components/attributeToggles';
import ProgressLoader from '../components/progressLoader';
import RcTooltip from 'rc-tooltip';
import { getApi } from "../utils/event_handling";
import ReactDOM from 'react-dom';
import SearchField from './components/SearchField';
import { Sparkles, Clock, CircleCheck, Activity, History, CalendarClock, CircleHelp, ClockCheck } from 'lucide-react';
import {normalizeAttributeName} from "../utils/attribute_name_utils.js";

const customSelectDatasource = ({ children, ...props }) => (
    <components.Control {...props} className="has-icon">
        <FontAwesomeIcon
            icon={faDatabase}
            className="form-control__icon"
        />
        {children}
    </components.Control>

);

const renderTooltipSummary = (props) => (
    <span {...props}>
        {props}
    </span>
);

// let nowDate;
// let nowDay;
export default class DQMetricsFullscreen extends React.Component {
    constructor(props) {

        super(props);

        // this.horizonScroll = React.createRef();

        this.rightScroll = React.createRef();
        this.letScroll = React.createRef();

        // this.closeBulkSchedule = this.closeBulkSchedule.bind(this);
        // this.saveBulkSchedule = this.saveBulkSchedule.bind(this);
        // this.confirmationBulkSchedule = this.confirmationBulkSchedule.bind(this);
        // this.returnBulkSchedule = this.returnBulkSchedule.bind(this);

        // this.confirmationDatasetSchedule = this.confirmationDatasetSchedule.bind(this);
        // this.returnDatasetSchedule = this.returnDatasetSchedule.bind(this);
        // this.bulkScheduleOption = this.bulkScheduleOption.bind(this);

        // this.handleToggle = this.handleToggle.bind(this);
        // this.onChange = this.onChange.bind(this)
        // this.postBulkScheduleData = postBulkScheduleData.bind(this);

        this.getMetricsMetadata = getMetricsMetadata.bind(this)

        // this.putThresholdData = putThresholdData.bind(this)
        this.postToggleAction = postToggleAction.bind(this)
        this.getApi = getApi.bind(this);
        // this.updateThresholdData = this.updateThresholdData.bind(this)

        // this.handleTimeFilter = this.handleTimeFilter.bind(this);
        // this.closeUpdateThreshold = this.closeUpdateThreshold.bind(this)
        this.showToast = this.showToast.bind(this);
        this.closeToast = this.closeToast.bind(this);
        // this.datasetPopover = this.datasetPopover.bind(this);
        this.scheduleTimePopover = this.scheduleTimePopover.bind(this)
        this.fetchScheduledInfo = this.fetchScheduledInfo.bind(this)
        this.searchData = this.searchData.bind(this);
        this.setSelectedDataset = this.setSelectedDataset.bind(this);
        this.adjustHeight = this.adjustHeight.bind(this)
        this.progressLoader = this.progressLoader.bind(this);

        // this.triggerFunction = this.triggerFunction.bind(this);
        // this.datasetToggle = this.datasetToggle.bind(this);

        // this.removeChipData = this.removeChipData.bind(this);

        // let startDate = moment().set({ "hour": 0, "minute": 0, "seconds": 0 });
        // let endDate = startDate
        // let now = new Date();
        // let day = now.getDay();
        // let currentDay = WEEKDAYS[day]

        // nowDate = startDate
        // nowDay = day


        this.state = {

            showScheduleMetric: true,
            showScheduleCalender: false,
            isScheduleMetricActive: true,
            isScheduleCalenderActive: false,
            filterData: this.props.filterData,
            environments: this.props.filterData['environments'],
            integrations: this.props.filterData['integrations'].filter((data) => this.props.existingIntegrations.includes(data.value)),
            datasets: this.props.filterData['datasets'],
            isOpen: false,
            applicableIntegrations: [],
            applicableDatasets: [],
            selectedEnv: "",
            selectedIntegration: [],
            selectedDatasets: [],
            sleepInterval: localStorage.getItem('globalScanInterval') || this.props.sleepInterval || 30,
            globalScanOption: localStorage.getItem('globalScanOption') || 'default',
            scheduledInfoByDataset: {},
            scheduledInfoLoadingId: null,
            showMore: true,
            // bulkScheduleData: {},
            // recurrence: { "label": "Daily", "value": "Daily" },
            // recurrenceList: [
            //     // { "label": "Does not repeat", "value": "Does not repeat" },
            //     { "label": "Daily", "value": "Daily" },
            //     { "label": "Weekly on " + currentDay, "value": "Weekly on " + currentDay },
            //     { "label": "Every Weekday(Monday to Friday)", "value": "Every Weekday(Monday to Friday)" },
            //     { "label": "Custom", "value": "Custom" }
            // ],

            // scheduleTimes: [{ "label": "12.00 AM", "value": "12.00 AM" }],
            // startDate: startDate,
            // endDate: endDate,
            // endDay: nowDay,
            // defaultSchedule: false,
            // selectedScheduleDay: [],
            // selectedScheduleTime: [],
            // timeRange: timeRange,
            // responseData: [],

            // datasetLevelPO: false,

            // currentDay: day,

            // color: "Blue",

            // check_value: null,
            // threshold_value: null,
            // allAttributes: false,

            metaDataMapping: this.props.metaDataMapping,
            metaDataList: this.props.metaDataList,
            // custom: false,

            // showConfirmation: false,
            errorOccurred: false,
            toastStatus: false,
            errors: {
            },
            selectedDatasource: null,

            emptyTrHeight: '',
            screenHeight: window.innerHeight,
            // tempMetaDataList: null,
            // confirmationData: {},
            // weekdaysClasses: {},
            // indexLimit: 5,

            expandText: 'See more',
            searchValue: '',

            filteredData: [],
            loader: false,

            // datasetPopover: false,

            isIconActive: false,
            // chipData: [],
            // bulkScheduleConfirmation: false,
            // datasetScheduleConfirmation: false,
            selectedAttributeCount: 0,
            existingIntegrations: this.props.existingIntegrations,
            enabledCount: this.props.enabledCount === undefined ? "" : this.props.enabledCount,
            metaDataCount: this.props.metaDataCount === undefined ? "" : this.props.metaDataCount,
            // datasetConfirmationData: null,
            // all_attributes: false
            showMoreDatasetId: '',
            showMoreStatus: true,
            renderFlag: 0,
            //Paging
            currentPage: 1,
            itemsPerPage: 5,
            totalItems: 0, // Total number of items (can come from props or API)
        }
    }

    totalPages = (metaDataList) => {
        const totalItems = metaDataList[0]['dataset_list'].length;
        const calculatedPages = Math.ceil(totalItems / this.state.itemsPerPage);
        this.setState({ totalItems:totalItems }, () => {
            // You could also set `totalPages` in state if you need it stored
            this.setState({ totalPages: calculatedPages });
        });
        return calculatedPages; // Return the value if needed immediately after calling this function
    };


    progressLoader() {
        this.setState({ loader: !this.state.loader })
    }

    // Calculate the range of items to display
    startItem = () => {
        return (this.state.currentPage - 1) * this.state.itemsPerPage + 1;
    };

    endItem = () => {
        return Math.min(this.state.currentPage * this.state.itemsPerPage, this.state.totalItems);
    };

    // Function to handle page changes
    changePage = (page) => {

        this.adjustHeight()
        const totalPages = Math.ceil(this.state.totalItems / this.state.itemsPerPage);
        if (page >= 1 && page <= totalPages) {
            this.setState({ currentPage: page });
        }
    };


    componentWillUnmount() {
        $('body').removeClass("overflow-hidden schedule-metric-page");
    }

    // Only re-render
    shouldComponentUpdate(nextProps, nextState) {

        if ($("body").hasClass("scheduleMetric-popover")) {
            $("#topCover").addClass("overflow-hidden")
        } else {
            $("#topCover").removeClass("overflow-hidden")
        }


        if((this.state.showMoreStatus !== nextState.showMoreStatus) || (this.state.enabledCount !== nextState.enabledCount) || (this.state.searchValue !== nextState.searchValue) || (this.state.toastStatus !== nextState.toastStatus) || (this.state.loader !== nextState.loader) || (this.state.showMoreDatasetId!==nextState.showMoreDatasetId) || this.state.currentPage!== nextState.currentPage ||  this.state.totalItems!== nextState.totalItems || this.state.scheduledInfoLoadingId !== nextState.scheduledInfoLoadingId || this.state.scheduledInfoByDataset !== nextState.scheduledInfoByDataset || this.state.globalScanOption !== nextState.globalScanOption || this.state.sleepInterval !== nextState.sleepInterval){
            // if(this.state.loader === false){
            //     $(".tbl-metric-enable").removeClass("qd-content-loading")
            // }
            return true; // skip re-render
        }
        return false; // skip re-render
    }

    componentDidMount() {

        $('body').click(function () {
            if ($("body").hasClass("scheduleMetric-popover") || $("body").hasClass("scheduledTime-popover")) {
                $("#topCover").addClass("overflow-hidden")
            } else {
                $("#topCover").removeClass("overflow-hidden")
            }
        });

        $('body').addClass("overflow-hidden schedule-metric-page");
        var div = document.getElementById('topCover');
        if (div !== null) {
            div.scrollTo({
                left: 0,  // Scroll 100 pixels more from the current position
                behavior: 'smooth'  // Enable smooth scrolling
            });
        }


        const self = this; // Store reference to the React component instance

        setTimeout(
            () => {
                $("#topCover").scroll(function (e) {
                    $('.loading-attribute').each(function () {
                        let pos = $(this).offset(),
                            wX = $(window).scrollLeft(), wY = $(window).scrollTop(),
                            wH = $(window).height(), wW = $(window).width(),
                            oH = $(this).outerHeight(), oW = $(this).outerWidth();

                        let loadid = $(this).attr('id');
                        let attributeData = $(this).data("attribute");
                        let metricData = $(this).data("metric");
                        let className = $(this).data("className");


                        // check the edges
                        if (pos.left >= wX && pos.top >= wY &&
                            oW + pos.left <= wX + wW && oH + pos.top <= wY + wH) {
                            let loadidElement = document.getElementById(loadid)
                            if (loadidElement) {

                                ReactDOM.render(<AttributeToggle
                                    activeMetrics={self.props.activeMetrics}
                                    closeFullScreen={self.props.closeFullScreen}
                                    className={className}
                                    attributeData={attributeData}
                                    metricData={metricData}
                                    postToggleAction={self.postToggleAction}
                                    showToast={self.showToast}
                                    getMetricsMetadata={self.getMetricsMetadata}
                                />, document.getElementById(loadid));
                                $("#" + loadid).removeClass("loading-attribute")
                                // $(this).removeClass("loading-attribute")
                            }
                        }
                        else
                            if (((pos.left <= wX && pos.left + oW > wX) ||
                                (pos.left >= wX && pos.left <= wX + wW)) &&
                                ((pos.top <= wY && pos.top + oH > wY) ||
                                    (pos.top >= wY && pos.top <= wY + wH))) {
                                let loadidElement = document.getElementById(loadid)
                                if (loadidElement) {

                                    ReactDOM.render(<AttributeToggle
                                        activeMetrics={self.props.activeMetrics}
                                        closeFullScreen={self.props.closeFullScreen}
                                        className={className}
                                        attributeData={attributeData}
                                        metricData={metricData}
                                        postToggleAction={self.postToggleAction}
                                        showToast={self.showToast}
                                        getMetricsMetadata={self.getMetricsMetadata}
                                    />, document.getElementById(loadid));
                                    $("#" + loadid).removeClass("loading-attribute")
                                }
                            }
                    })

                });
            },
            500
        );


        // this.getApi("filterData");
        // this.getApi("dd_sleep_time_fetch");

        // this.getMetricsMetadata();


        // $('body').addClass("overflow-hidden schedule-metric-page");
        // Calculate height on component mount
        // this.calculateOccupiedHeight();
        // //Window Object has 'resize' event, whenever window gets resized this event gets triggered and handleWindowResize() gets called
        // window.addEventListener('resize', this.handleWindowResize);

    }

    adjustHeight(){

        setTimeout(
            () => {
                let height = $(window).height();
                let table_metaDataBody_height = $('#metaDataBody').height();
                if(height>table_metaDataBody_height){
                    height =  height-table_metaDataBody_height;
                        if(height>10){
                        $('.emptyrow').height(height);
                        }
                }else {
                    $('.emptyrow').height("0");
                }
            },
            1000
        );
    }
    componentDidUpdate(prevProps, prevState) {
        if (JSON.stringify(prevProps.metaDataList) !== JSON.stringify(this.props.metaDataList)) {
            this.setState({
                metaDataList: this.props.metaDataList,
            })
        }
                    // if(this.state.loader === false){
            //     $(".tbl-metric-enable").removeClass("qd-content-loading")
            // }

        // || (prevState.showMoreDatasetId!== this.state.showMoreDatasetId)
        if ((prevState.loader !== this.state.loader && this.state.loader === false)) {
         $(".tbl-metric-enable").removeClass("qd-content-loading")
        }



    }
    handleScheduleMetricTabs = (e) => {
        if (e.currentTarget.name === "scheduleMetric") {
            this.setState({ isScheduleMetricActive: true, isScheduleCalenderActive: false, showScheduleMetric: true, showScheduleCalender: false });
        }
        if (e.currentTarget.name === "scheduleCalender") {
            this.setState({ isScheduleCalenderActive: true, isScheduleMetricActive: false, showScheduleMetric: false, showScheduleCalender: true });
        }
    }

    setSelectedDataset(id, status, loader_id) {
        $("#spinner_"+loader_id).removeClass("d-none")
        $("#showmore_"+loader_id).addClass("d-none")
        setTimeout(
            () => {
                this.setState({ 'showMoreDatasetId': id, 'showMoreStatus': status })
            },
            2000
        );
    }

    showToast(status, msg, link) {
        this.setState({
            toastStatus: true,
            toastMsg: msg,
            toastClass: toastObj[status]["className"],
            nextPage: link,
            toastIcon: toastObj[status]["icon"],
            toastHeading: toastObj[status]["heading"]
        });
    }

    closeToast() {
        this.setState({ toastStatus: false });
    }

    fetchScheduledInfo = (dataset, integrationId) => {
        const datasetId = dataset?.dataset_id;
        const cacheKey = String(datasetId);
        if (!datasetId || !integrationId) return;

        // Reuse cached API response for this dataset
        if (this.state.scheduledInfoByDataset?.[cacheKey]?._fromApi) return;
        if (this.state.scheduledInfoLoadingId === cacheKey) return;

        this.setState({ scheduledInfoLoadingId: cacheKey });

        const requestParams = {
            data_set_id: Number(datasetId),
            tenant_id: Number(localStorage.getItem('team_id')),
            integration_id: Number(integrationId),
        };

        getScheduledInfo(requestParams).then((res) => {
            let apiDataset = null;
            const code = Number(res?.code);
            const responseBody = res?.response ?? res?.data ?? res;

            if (code === 200 && responseBody) {
                const list = Array.isArray(responseBody.dataset_list)
                    ? responseBody.dataset_list
                    : (Array.isArray(responseBody) ? responseBody : []);
                const listItem = list.find((item) => Number(item?.dataset_id) === Number(datasetId))
                    || list[0]
                    || null;
                const source = listItem
                    || (responseBody.dataset_id || responseBody.type || responseBody.next_scheduled_time
                        ? responseBody
                        : null);

                if (source) {
                    const scheduleType = source.type
                        || source.schedule_type
                        || source.scan_type
                        || source.mode
                        || responseBody.type
                        || responseBody.schedule_type
                        || responseBody.scan_type
                        || null;
                    apiDataset = {
                        ...dataset,
                        ...source,
                        type: scheduleType || source.type,
                        schedule_type: scheduleType,
                        _fromApi: true,
                    };
                }
            }

            this.setState((prev) => ({
                scheduledInfoLoadingId: null,
                scheduledInfoByDataset: {
                    ...prev.scheduledInfoByDataset,
                    [cacheKey]: apiDataset || { ...dataset, _fromApi: false, _apiError: true },
                },
            }));
        }).catch(() => {
            this.setState((prev) => ({
                scheduledInfoLoadingId: null,
                scheduledInfoByDataset: {
                    ...prev.scheduledInfoByDataset,
                    [cacheKey]: { ...dataset, _fromApi: false, _apiError: true },
                },
            }));
        });
    };

    /** Normalize API schedule type → "auto" | "default" | null */
    resolveApiScheduleMode = (scheduleDataset) => {
        const original = (
            scheduleDataset?.schedule_type
            || scheduleDataset?.scan_type
            || scheduleDataset?.type
            || scheduleDataset?.mode
            || ""
        ).toString().trim();
        const raw = original.toLowerCase().replace(/[\s_-]/g, "");

        if (!raw) return null;
        if (raw.startsWith("autoscan") || raw === "auto" || raw === "smart") return "auto";
        // "Every", "Every 30 Mins", "every30mins", "default", "fixed"
        if (raw.startsWith("every") || raw === "default" || raw === "fixed" || raw === "interval") {
            return "default";
        }
        return null;
    };

    /** Prefer API type label like "Every 30 Mins"; else build from interval */
    getEveryScheduleTitle = (scheduleDataset, intervalMin) => {
        const typeLabel = (
            scheduleDataset?.schedule_type
            || scheduleDataset?.type
            || ""
        ).toString().trim();
        if (/^every\b/i.test(typeLabel)) {
            return typeLabel;
        }
        return `Every ${intervalMin} min`;
    };

    /** Resolve minutes from interval field or "Every 30 Mins" type text */
    getEveryIntervalMinutes = (scheduleDataset, fallback) => {
        const fromField = parseInt(
            scheduleDataset?.interval_min
            || scheduleDataset?.sleep_interval
            || scheduleDataset?.interval
            || scheduleDataset?.every,
            10
        );
        if (!Number.isNaN(fromField) && fromField > 0) return fromField;

        const typeLabel = (
            scheduleDataset?.schedule_type
            || scheduleDataset?.type
            || ""
        ).toString();
        const match = typeLabel.match(/every\s+(\d+)/i);
        if (match) {
            const mins = parseInt(match[1], 10);
            if (!Number.isNaN(mins) && mins > 0) return mins;
        }
        return fallback;
    };

    handleSchedulePopoverToggle = (isOpen, dataset, integrationId) => {
        this.popoverAction(dataset);
        if (isOpen) {
            this.fetchScheduledInfo(dataset, integrationId);
        }
    };

    scheduleTimePopover(dataset, scheduledOn, nextScheduledTime, defaultScan, overlayProps = {}) {
        const datasetId = dataset?.dataset_id;
        const cacheKey = String(datasetId);
        const apiMerged = this.state.scheduledInfoByDataset?.[cacheKey];
        const fromApi = !!(apiMerged && apiMerged._fromApi);
        // Only show loading while the request is in flight
        const isLoading = this.state.scheduledInfoLoadingId === cacheKey && !fromApi && !apiMerged?._apiError;
        const scheduleDataset = fromApi ? apiMerged : (apiMerged || dataset);

        if (isLoading) {
            return (
                <Popover
                    {...overlayProps}
                    key={`scheduled-loading-${cacheKey}`}
                    id={`scheduled-time-${cacheKey}-loading`}
                    className={`popover-theme-blue scheduledTime-popover ${overlayProps.className || ''}`.trim()}
                >
                    <Popover.Content>
                        <div className="tw-overflow-hidden tw-rounded-xl tw-bg-white tw-px-4 tw-py-5 tw-text-center">
                            <span className="tw-text-xs tw-text-gray-500">Loading schedule info…</span>
                        </div>
                    </Popover.Content>
                </Popover>
            );
        }

        const globalOption = this.state.globalScanOption
            || localStorage.getItem('globalScanOption')
            || 'default';
        const fallbackInterval = parseInt(
            this.state.sleepInterval
            || localStorage.getItem('globalScanInterval')
            || 30,
            10
        );
        const intervalMin = this.getEveryIntervalMinutes(scheduleDataset, fallbackInterval);

        const gmtTime = scheduleDataset.next_scheduled_time || nextScheduledTime;
        const now = moment();
        const nextTime = moment(gmtTime);
        const diffMs = nextTime.isValid() ? nextTime.diff(now) : NaN;

        let nextRunRelative = "";
        if (diffMs > 0) {
            const duration = moment.duration(diffMs);
            const hours = Math.floor(duration.asHours());
            const mins = duration.minutes();
            nextRunRelative = hours > 0 ? `in ${hours}h` : `in ${mins}m`;
        }

        const nextRunTimeOnly = nextTime.isValid() ? nextTime.utc().format("h:mm A") : "";
        const nextRunFull = nextRunTimeOnly
            ? (nextRunRelative ? `${nextRunRelative} · ${nextRunTimeOnly}` : nextRunTimeOnly)
            : "N/A";

        // Custom schedule only when API returns real scheduling_time JSON (not "null")
        let resolvedScheduledOn = scheduledOn;
        let resolvedDefaultScan = defaultScan;
        let scheduledTimes = scheduleDataset.scheduledTimes || [];

        const rawSchedulingTime = scheduleDataset.scheduling_time;
        let parsedScheduling = null;
        if (rawSchedulingTime && rawSchedulingTime !== "null" && rawSchedulingTime !== null) {
            try {
                parsedScheduling = typeof rawSchedulingTime === "string"
                    ? JSON.parse(rawSchedulingTime)
                    : rawSchedulingTime;
            } catch (e) {
                parsedScheduling = null;
            }
        }

        if (scheduleDataset.payload != null && parsedScheduling && typeof parsedScheduling === "object") {
            const days = Object.keys(parsedScheduling);
            if (days.length > 0) {
                const schedulingTime = parsedScheduling[days[0]];
                scheduledTimes = timeRange.map((slot) => {
                    if (Array.isArray(schedulingTime) && schedulingTime.includes(slot.value)) {
                        return slot.label;
                    }
                    return null;
                }).filter(Boolean);
                resolvedScheduledOn = scheduleDataset.payload?.repeat_on || resolvedScheduledOn;
                resolvedDefaultScan = false;
            }
        } else if (fromApi) {
            resolvedDefaultScan = true;
        }

        // API type wins: "Every 30 Mins" → default, "AutoScan" → auto
        const apiMode = this.resolveApiScheduleMode(scheduleDataset);
        let mode = "custom";
        if (apiMode) {
            mode = apiMode;
        } else if (resolvedDefaultScan === true) {
            mode = globalOption === "auto" ? "auto" : "default";
        }

        let headerBg, icon, title, badgeText, badgeColorClass, subtext, titleColorClass;
        let rows = [];
        let showScanTimes = false;

        if (mode === "default") {
            // type: "Every 30 Mins" — title from type; values from API fields
            const scansPerDay = Math.round(1440 / Math.max(1, intervalMin || 60));
            const lastRunText = scheduleDataset.last_refresh
                || scheduleDataset.last_scan
                || "—";
            const nextRefreshValue = scheduleDataset.next_refresh
                || nextRunTimeOnly
                || nextRunFull
                || "—";
            const frequencyValue = scheduleDataset.frequency
                || `≈ ${scansPerDay} scans / day`;

            headerBg = "tw-bg-[#334DB70d]";
            titleColorClass = "tw-text-[#25388c]";
            icon = <ClockCheck className="tw-w-[14px] tw-h-[14px] tw-text-[#334DB7] tw-mr-1.5" />;
            title = this.getEveryScheduleTitle(scheduleDataset, intervalMin);
            badgeText = "DEFAULT";
            badgeColorClass = "tw-text-[#334DB7] tw-border-[#334DB740]";
            subtext = "Fixed interval, inherited from the global default.";

            rows = [
                { icon: <Clock className="tw-w-3 tw-h-3 tw-mr-1.5 tw-opacity-80" />, label: "Next refresh", value: nextRefreshValue },
                { icon: <CircleCheck className="tw-w-3 tw-h-3 tw-mr-1.5 tw-opacity-80" />, label: "Last refresh", value: lastRunText },
                { icon: <Activity className="tw-w-3 tw-h-3 tw-mr-1.5 tw-opacity-80" />, label: "Frequency", value: frequencyValue }
            ];
        } else if (mode === "auto") {
            // type: "AutoScan"
            headerBg = "tw-bg-emerald-50/70";
            titleColorClass = "tw-text-emerald-900";
            icon = <Sparkles className="tw-w-[14px] tw-h-[14px] tw-text-emerald-600 tw-mr-1.5" />;
            title = "Auto scan";
            badgeText = "SMART";
            badgeColorClass = "tw-text-emerald-600 tw-border-emerald-200";
            subtext = "Scans automatically when Qualdo detects new or refreshed data — no fixed timer.";

            const yesterdayValue = scheduleDataset.yesterday_scans
                || scheduleDataset.yesterday
                || (scheduleDataset.yesterday_scan_count != null
                    ? `~${scheduleDataset.yesterday_scan_count} scans`
                    : "—");

            rows = [
                { icon: <CircleCheck className="tw-w-3 tw-h-3 tw-mr-1.5 tw-opacity-80" />, label: "Last scan", value: scheduleDataset.last_scan || scheduleDataset.last_refresh || "—" },
                { icon: <Clock className="tw-w-3 tw-h-3 tw-mr-1.5 tw-opacity-80" />, label: "Next refresh", value: scheduleDataset.next_refresh || "on data activity" },
                { icon: <History className="tw-w-3 tw-h-3 tw-mr-1.5 tw-opacity-80" />, label: "Yesterday", value: yesterdayValue }
            ];
        } else {
            const recurrenceText = (resolvedScheduledOn && resolvedScheduledOn.value) ? resolvedScheduledOn.value : "Custom";
            const customTitle = nextRunTimeOnly ? `${recurrenceText} · ${nextRunTimeOnly}` : recurrenceText;

            headerBg = "tw-bg-[#DC68030d]";
            titleColorClass = "tw-text-[#B54708]";
            icon = <CalendarClock className="tw-w-[14px] tw-h-[14px] tw-text-[#DC6803] tw-mr-1.5" />;
            title = customTitle;
            badgeText = "CUSTOM";
            badgeColorClass = "tw-text-[#DC6803] tw-border-[#DC680340]";
            subtext = `${recurrenceText} schedule set for this dataset — overrides the global default.`;

            rows = [
                { icon: <Clock className="tw-w-3 tw-h-3 tw-mr-1.5 tw-opacity-80" />, label: "Next refresh", value: nextRunFull },
                { icon: <CircleCheck className="tw-w-3 tw-h-3 tw-mr-1.5 tw-opacity-80" />, label: "Last refresh", value: scheduleDataset.last_refresh || "—" }
            ];
            showScanTimes = true;
        }

        return (
            <Popover
                {...overlayProps}
                key={`scheduled-ready-${cacheKey}-${fromApi ? 'api' : 'local'}`}
                id={`scheduled-time-${cacheKey}`}
                className={`popover-theme-blue scheduledTime-popover ${overlayProps.className || ''}`.trim()}
            >
                <Popover.Content>
                    <div className="tw-overflow-hidden tw-rounded-xl tw-bg-white">
                        <div className={`${headerBg} tw-px-3.5 tw-py-2 tw-flex tw-items-center tw-justify-between`}>
                            <div className="tw-flex tw-items-center">
                                {icon}
                                <span className={`tw-text-sm tw-font-medium ${titleColorClass}`}>{title}</span>
                            </div>
                            <span className={`tw-text-[9px] tw-font-medium tw-uppercase tw-tracking-wide tw-px-2 tw-py-0.5 tw-rounded-full tw-bg-white tw-border tw-border-solid ${badgeColorClass}`}>
                                {badgeText}
                            </span>
                        </div>
                        <div className="tw-px-3 tw-pt-3 tw-pb-1">
                            <p className="tw-text-xs tw-text-[#484848] tw-m-0 tw-leading-relaxed">
                                {subtext}
                            </p>
                            <div className="tw-my-3 tw-border-0 tw-border-t tw-border-solid tw-border-gray-100"></div>
                            <div className="tw-flex tw-flex-col tw-gap-1.5 tw-my-3">
                                {rows.map((row, idx) => (
                                    <div key={idx} className="tw-flex tw-items-center tw-justify-between">
                                        <div className="tw-flex tw-items-center tw-text-gray-500">
                                            {row.icon}
                                            <span className="tw-text-xs">{row.label}</span>
                                        </div>
                                        <span className="tw-text-xs tw-font-medium tw-text-gray-800">{row.value}</span>
                                    </div>
                                ))}
                            </div>

                            {showScanTimes && scheduledTimes.length > 0 && (
                                <>
                                    <div className="tw-my-3 tw-border-0 tw-border-t tw-border-solid tw-border-gray-100"></div>
                                    <div className="tw-text-[9px] tw-font-bold tw-text-gray-400 tw-uppercase tw-tracking-wider tw-mb-1.5">
                                        SCAN TIMES · GMT
                                    </div>
                                    <div className="tw-flex tw-flex-wrap tw-gap-1.5 tw-mb-3">
                                        {scheduledTimes.map((time, idx) => {
                                            const parts = time.split(".");
                                            const hrs = parseInt(parts[0] || 0, 10);
                                            const mins = parseInt(parts[1] || 0, 10);
                                            const scanTimeToday = moment.utc().set({ hour: hrs, minute: mins, second: 0, millisecond: 0 });
                                            const isDone = moment.utc().isAfter(scanTimeToday);
                                            const formatted = time.replace(".", ":");

                                            if (isDone) {
                                                return (
                                                    <span key={idx} className="tw-text-[10px] tw-font-semibold tw-rounded-md tw-px-1.5 tw-py-0.5 tw-bg-[#DC68030d] tw-text-[#DC6803] tw-border tw-border-solid tw-border-[#DC680320] tw-inline-flex tw-items-center">
                                                        <CircleCheck className="tw-w-2.5 tw-h-2.5 tw-mr-1 tw-shrink-0" />
                                                        {formatted}
                                                    </span>
                                                );
                                            }
                                            return (
                                                <span key={idx} className="tw-text-[10px] tw-font-medium tw-rounded-md tw-px-1.5 tw-py-0.5 tw-bg-gray-100 tw-text-gray-500 tw-border tw-border-solid tw-border-gray-200 tw-inline-flex tw-items-center">
                                                    <Clock className="tw-w-2.5 tw-h-2.5 tw-mr-1 tw-shrink-0" />
                                                    {formatted}
                                                </span>
                                            );
                                        })}
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </Popover.Content>
            </Popover>
        );
    }  
    scheduleTimePopoverold(dataset, scheduledOn, nextScheduledTime, defaultScan) {
        // let className = "scheduledTime__list-item"
 const globalOption = this.state.globalScanOption || localStorage.getItem('globalScanOption') || 'default';
        const globalInterval = parseInt(this.state.sleepInterval || localStorage.getItem('globalScanInterval') || 30, 10);

        // Next run details
        const gmtTime = dataset['next_scheduled_time'];
        const now = moment();
        const nextTime = moment(gmtTime);
        const diffMs = nextTime.diff(now);
        
        let nextRunRelative = "";
        if (diffMs > 0) {
            const duration = moment.duration(diffMs);
            const hours = Math.floor(duration.asHours());
            const mins = duration.minutes();
            if (hours > 0) {
                nextRunRelative = `in ${hours}h`;
            } else {
                nextRunRelative = `in ${mins}m`;
            }
        } else {
            nextRunRelative = "";
        }
        
        const nextRunTimeOnly = nextTime.isValid() ? nextTime.utc().format("h:mm A") : "";
        const nextRunFull = nextRunTimeOnly ? `${nextRunRelative} · ${nextRunTimeOnly}` : "N/A";

        // Determine active mode
        let mode = "custom";
        if (defaultScan === true) {
            if (globalOption === "auto") {
                mode = "auto";
            } else {
                mode = "default";
            }
        }

        let headerBg, icon, title, badgeText, badgeColorClass, subtext, titleColorClass;
        let rows = [];
        let showScanTimes = false;

        if (mode === "default") {
            const scansPerDay = Math.round(1440 / globalInterval);
            
            // Calculate last run dynamically
            const lastTime = nextTime.clone().subtract(globalInterval, 'minutes');
            const lastRunDiff = now.diff(lastTime);
            let lastRunText = "";
            if (lastRunDiff > 0) {
                const dur = moment.duration(lastRunDiff);
                const hrs = Math.floor(dur.asHours());
                const mins = dur.minutes();
                lastRunText = hrs > 0 ? `${hrs}h ago` : `${mins}m ago`;
            } else {
                lastRunText = "just now";
            }

            headerBg = "tw-bg-[#334DB70d]";
            titleColorClass = "tw-text-[#25388c]";
            icon = <ClockCheck className="tw-w-[14px] tw-h-[14px] tw-text-[#334DB7] tw-mr-1.5" />;
            title = `Every ${globalInterval} min`;
            badgeText = "DEFAULT";
            badgeColorClass = "tw-text-[#334DB7] tw-border-[#334DB740]";
            subtext = "Fixed interval, inherited from the global default.";
            
            rows = [
                { icon: <Clock className="tw-w-3 tw-h-3 tw-mr-1.5 tw-opacity-80" />, label: "Next refresh", value: nextRunFull },
                { icon: <CircleCheck className="tw-w-3 tw-h-3 tw-mr-1.5 tw-opacity-80" />, label: "Last refresh", value: lastRunText },
                { icon: <Activity className="tw-w-3 tw-h-3 tw-mr-1.5 tw-opacity-80" />, label: "Frequency", value: `≈ ${scansPerDay} scans / day` }
            ];
        } else if (mode === "auto") {
            headerBg = "tw-bg-emerald-50/70";
            titleColorClass = "tw-text-emerald-900";
            icon = <Sparkles className="tw-w-[14px] tw-h-[14px] tw-text-emerald-600 tw-mr-1.5" />;
            title = "Auto scan";
            badgeText = "SMART";
            badgeColorClass = "tw-text-emerald-600 tw-border-emerald-200";
            subtext = "Scans automatically when Qualdo detects new or refreshed data — no fixed timer.";
            
            rows = [
                { icon: <CircleCheck className="tw-w-3 tw-h-3 tw-mr-1.5 tw-opacity-80" />, label: "Last scan", value: "6m ago" },
                { icon: <Clock className="tw-w-3 tw-h-3 tw-mr-1.5 tw-opacity-80" />, label: "Next refresh", value: "on data activity" },
                { icon: <History className="tw-w-3 tw-h-3 tw-mr-1.5 tw-opacity-80" />, label: "Yesterday", value: "~18 scans" }
            ];
        } else {
            const recurrenceText = (scheduledOn && scheduledOn['value']) ? scheduledOn['value'] : "Custom";
            const customTitle = nextRunTimeOnly ? `${recurrenceText} · ${nextRunTimeOnly}` : recurrenceText;

            headerBg = "tw-bg-[#DC68030d]";
            titleColorClass = "tw-text-[#B54708]";
            icon = <CalendarClock className="tw-w-[14px] tw-h-[14px] tw-text-[#DC6803] tw-mr-1.5" />;
            title = customTitle;
            badgeText = "CUSTOM";
            badgeColorClass = "tw-text-[#DC6803] tw-border-[#DC680340]";
            subtext = `${recurrenceText} schedule set for this dataset — overrides the global default.`;
            
            rows = [
                { icon: <Clock className="tw-w-3 tw-h-3 tw-mr-1.5 tw-opacity-80" />, label: "Next refresh", value: nextRunFull },
                { icon: <CircleCheck className="tw-w-3 tw-h-3 tw-mr-1.5 tw-opacity-80" />, label: "Last refresh", value: "Yesterday" }
            ];
            showScanTimes = true;
        }

        const scheduledTimes = dataset['scheduledTimes'] || [];
        return (
            <Popover className="popover-theme-blue scheduledTime-popover">
                <Popover.Content>
                    <div className="tw-overflow-hidden tw-rounded-xl tw-bg-white">
                        {/* Header */}
                        <div className={`${headerBg} tw-px-3.5 tw-py-2 tw-flex tw-items-center tw-justify-between`}>
                            <div className="tw-flex tw-items-center">
                                {icon}
                                <span className={`tw-text-sm tw-font-medium ${titleColorClass}`}>{title}</span>
                            </div>
                            <span className={`tw-text-[9px] tw-font-medium tw-uppercase tw-tracking-wide tw-px-2 tw-py-0.5 tw-rounded-full tw-bg-white tw-border tw-border-solid ${badgeColorClass}`}>
                                {badgeText}
                            </span>
                        </div>
                        {/* Body */}
                        <div className="tw-px-3 tw-pt-3 tw-pb-1">
                            <p className="tw-text-xs tw-text-[#484848] tw-m-0 tw-leading-relaxed">
                                {subtext}
                            </p>
                            <div className="tw-my-3 tw-border-0 tw-border-t tw-border-solid tw-border-gray-100"></div>
                            <div className="tw-flex tw-flex-col tw-gap-1.5 tw-my-3">
                                {rows.map((row, idx) => (
                                    <div key={idx} className="tw-flex tw-items-center tw-justify-between">
                                        <div className="tw-flex tw-items-center tw-text-gray-500">
                                            {row.icon}
                                            <span className="tw-text-xs">{row.label}</span>
                                        </div>
                                        <span className="tw-text-xs tw-font-medium tw-text-gray-800">{row.value}</span>
                                    </div>
                                ))}
                            </div>

                            {showScanTimes && scheduledTimes.length > 0 && (
                                <>
                                    <div className="tw-my-3 tw-border-0 tw-border-t tw-border-solid tw-border-gray-100"></div>
                                    <div className="tw-text-[9px] tw-font-bold tw-text-gray-400 tw-uppercase tw-tracking-wider tw-mb-1.5">
                                        SCAN TIMES · GMT
                                    </div>
                                    <div className="tw-flex tw-flex-wrap tw-gap-1.5 tw-mb-3">
                                        {scheduledTimes.map((time, idx) => {
                                            const parts = time.split(".");
                                            const hrs = parseInt(parts[0] || 0, 10);
                                            const mins = parseInt(parts[1] || 0, 10);
                                            const scanTimeToday = moment.utc().set({ hour: hrs, minute: mins, second: 0, millisecond: 0 });
                                            const isDone = moment.utc().isAfter(scanTimeToday);
                                            const formatted = time.replace(".", ":");
                                            
                                            if (isDone) {
                                                return (
                                                    <span key={idx} className="tw-text-[10px] tw-font-semibold tw-rounded-md tw-px-1.5 tw-py-0.5 tw-bg-[#DC68030d] tw-text-[#DC6803] tw-border tw-border-solid tw-border-[#DC680320] tw-inline-flex tw-items-center">
                                                        <CircleCheck className="tw-w-2.5 tw-h-2.5 tw-mr-1 tw-shrink-0" />
                                                        {formatted}
                                                    </span>
                                                );
                                            } else {
                                                return (
                                                    <span key={idx} className="tw-text-[10px] tw-font-medium tw-rounded-md tw-px-1.5 tw-py-0.5 tw-bg-gray-100 tw-text-gray-500 tw-border tw-border-solid tw-border-gray-200 tw-inline-flex tw-items-center">
                                                        <Clock className="tw-w-2.5 tw-h-2.5 tw-mr-1 tw-shrink-0" />
                                                        {formatted}
                                                    </span>
                                                );
                                            }
                                        })}
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </Popover.Content>
            </Popover>
        );
    }  
    searchData(searchValue) {

        let data = JSON.parse(JSON.stringify(this.state.metaDataList))
        // let filteredData = data.map(item => ({
        //     ...item,
        //     dataset_list: item.dataset_list.map(dataset => ({
        //         ...dataset,
        //         attribute_list: dataset.attribute_list.filter(attr => attr.attribute_name.toLowerCase().includes(searchValue.toLowerCase()) || this.state.metaDataMapping[attr.dataset_id].toLowerCase().includes(searchValue.toLowerCase()))
        //     }))
        // }));
        this.changePage(1)
        let filteredData = data.map(item => ({
            ...item,
            dataset_list: item.dataset_list
                .map(dataset => {
                    // Filter the attribute list based on the search criteria
                    const filteredAttributes = dataset.attribute_list.filter(attr =>
                        attr.attribute_name.toLowerCase().includes(searchValue.toLowerCase()) ||
                        this.state.metaDataMapping[dataset.dataset_id].toLowerCase().includes(searchValue.toLowerCase())
                    );
                    // Only return datasets where filtered attributes exist
                    if (filteredAttributes.length > 0) {
                        return {
                            ...dataset,
                            attribute_list: filteredAttributes,
                            dataset_id: dataset.dataset_id // Ensure dataset_id is included
                        };
                    }
                    return null
                })
                .filter(Boolean)
            // Remove datasets that don't have any matching attributes
        }
        ));
        this.setState({ filteredData: filteredData, searchValue: searchValue });
    }

    scrollLeft = () => {
        $('tbody, metaDataBody').animate({
            scrollLeft: '-=200' // Adjust the scroll distance as needed
        }, 500); // Adjust the animation duration as needed
    };

    scrollRight = () => {
        $('html, body').animate({
            scrollLeft: '+=200' // Adjust the scroll distance as needed
        }, 500); // Adjust the animation duration as needed
    };

    scrollToLeft = () => {
        // this.rightScroll.current.scrollLeft -= 2000;
        var div = document.getElementById('topCover');
        div.scrollTo({
            left: div.scrollLeft - 100,  // Scroll 100 pixels more from the current position
            behavior: 'smooth'  // Enable smooth scrolling
        });
        // this.letScroll.current.scrollLeft += 2000; // Adjust the scroll distance as needed
    };

    scrollToRight = () => {
        this.rightScroll.current.scrollLeft += 2000; // Adjust the scroll distance as needed
        var div = document.getElementById('topCover');
        div.scrollTo({
            left: div.scrollLeft + 100,  // Scroll 100 pixels more from the current position
            behavior: 'smooth'  // Enable smooth scrolling
        });

    };

    popoverAction() {
        if ($('#topCover').hasClass('overflow-hidden')) {
            $('#topCover').removeClass("overflow-hidden");
        }
        else {
            $('#topCover').addClass("overflow-hidden");
        }

    };

    bodyscrollhide() {
        $("#topCover").addClass("overflow-hidden")
    }
    clearSearch() {
        this.setState({
            searchValue: '',
            filteredData:''
        });
    }
    render() {
        // let adjustHeight = [1, 1, 1, 1, 1, 1, 1, 1, 1]
        const { currentPage } = this.state;


        // const { isScheduleMetricActive, isScheduleCalenderActive, showScheduleMetric,
        // showScheduleCalender
        // } = this.state;

        // let metaDataList_orginal = this.state.metaDataList;
        let metaDataList_copy = [...this.state.metaDataList]; // Create a copy
        // let enabledCount = { integrations: {}, datasets: {}, attributes: {} }
        // let metaDataCount = { integrations: 0, datasets: 0, attributes: 0 }

        // metaDataList.map((integrationData, integrationIndex) => {
        //     metaDataCount['integrations'] = metaDataCount['integrations'] + 1
        //     integrationData['metric_info'].map((integrationMeticData, integrationMetricIndex) => {
        //         if (integrationMeticData.is_enable === 1 || integrationMeticData.is_enable === true) {
        //             if (enabledCount['integrations'][integrationMeticData.metrics_name] === undefined) {
        //                 enabledCount['integrations'][integrationMeticData.metrics_name] = {}
        //                 enabledCount['integrations'][integrationMeticData.metrics_name]['enabled'] = 0
        //             }
        //             enabledCount['integrations'][integrationMeticData.metrics_name]['enabled'] = enabledCount['integrations'][integrationMeticData.metrics_name]['enabled'] + 1
        //         }
        //         return null
        //     })
        //     integrationData['dataset_list'].map((datasetData, datasetIndex) => {
        //         metaDataCount['datasets'] = metaDataCount['datasets'] + 1
        //         datasetData['metric_info'].map((datasetMetric, datasetMetricIndex) => {
        //             if (datasetMetric.is_enable === 1 || datasetMetric.is_enable === true) {
        //                 if (enabledCount['datasets'][datasetMetric.metrics_name] === undefined) {
        //                     enabledCount['datasets'][datasetMetric.metrics_name] = {}
        //                     enabledCount['datasets'][datasetMetric.metrics_name]['enabled'] = 0
        //                 }
        //                 enabledCount['datasets'][datasetMetric.metrics_name]['enabled'] = enabledCount['datasets'][datasetMetric.metrics_name]['enabled'] + 1
        //             }
        //             return null
        //         })
        //         if (enabledCount['attributes'][datasetData.dataset_id] === undefined) {
        //             enabledCount['attributes'][datasetData.dataset_id] = {}
        //             enabledCount['attributes'][datasetData.dataset_id]['attributeCount'] = 0
        //         }


        //         datasetData['attribute_list'].map((attributeDatas, attributeIndex) => {
        //             metaDataCount['attributes'] = metaDataCount['attributes'] + 1
        //             attributeDatas['metric_info'].map((attributeMetric, attributeMetricIndex) => {
        //                 if (attributeMetric.is_enable === 1 || attributeMetric.is_enable === true) {
        //                     if (enabledCount['attributes'][attributeMetric.metrics_name] === undefined) {
        //                         enabledCount['attributes'][attributeMetric.metrics_name] = {}
        //                         enabledCount['attributes'][attributeMetric.metrics_name]['enabled'] = 0
        //                     }

        //                     if (datasetData['attribute_list'] !== undefined) {
        //                         enabledCount['attributes'][datasetData.dataset_id]['attributeCount'] = datasetData['attribute_list'].length
        //                     }

        //                     if (enabledCount['attributes'][datasetData.dataset_id] !== undefined && enabledCount['attributes'][datasetData.dataset_id][attributeMetric.metrics_name] === undefined) {
        //                         enabledCount['attributes'][datasetData.dataset_id][attributeMetric.metrics_name] = {}
        //                         enabledCount['attributes'][datasetData.dataset_id][attributeMetric.metrics_name]['enabled'] = 0
        //                         enabledCount['attributes'][datasetData.dataset_id][attributeMetric.metrics_name]['attributeCount'] = 1
        //                     }
        //                     enabledCount['attributes'][datasetData.dataset_id][attributeMetric.metrics_name]['attributeCount'] = enabledCount['attributes'][datasetData.dataset_id][attributeMetric.metrics_name]['attributeCount'] + 1
        //                     enabledCount['attributes'][attributeMetric.metrics_name]['enabled'] = enabledCount['attributes'][attributeMetric.metrics_name]['enabled'] + 1
        //                     enabledCount['attributes'][datasetData.dataset_id][attributeMetric.metrics_name]['enabled'] = enabledCount['attributes'][datasetData.dataset_id][attributeMetric.metrics_name]['enabled'] + 1

        //                 }
        //                 else {
        //                     if (enabledCount['attributes'][datasetData.dataset_id] === undefined) {
        //                         enabledCount['attributes'][datasetData.dataset_id] = {}
        //                     }
        //                     if (datasetData['attribute_list'] !== undefined) {
        //                         enabledCount['attributes'][datasetData.dataset_id]['attributeCount'] = datasetData['attribute_list'].length
        //                     }
        //                 }
        //                 return null
        //             })
        //             return null
        //         })
        //         return null
        //     })
        //     return null
        // })
        // let totalCount = metaDataCount['integrations']+metaDataCount['datasets']+metaDataCount['attributes']
        let enabledCount = this.state.enabledCount
        let metaDataCount = this.state.metaDataCount

        let showMoreDatasetId = this.state.showMoreDatasetId !== "" ? this.state.showMoreDatasetId : "";
        // let showMoreStatus = this.state.showMoreStatus;
        let metaDataList = this.state.filteredData.length > 0 ? this.state.filteredData : metaDataList_copy
        let defaultDatasource = []
        let totalPages = []
        if (metaDataList.length > 0) {
            defaultDatasource = { label: this.state.metaDataMapping[metaDataList[0]['integration_id']], value: metaDataList[0]['integration_id'] }
            totalPages = this.totalPages(metaDataList);
        }

        return (
            <>
                <div id="toastMsg">
                    <Toast className={this.state.toastClass}
                        onClose={() => this.closeToast()}
                        show={this.state.toastStatus}
                        delay={3000} autohide>
                        <div className="d-flex align-items-center">
                            {this.state.toastStatus ?
                                <i className="toast-icon">
                                    <FontAwesomeIcon icon={this.state.toastIcon} />
                                </i>
                                :
                                ''
                            }

                            <Toast.Body>
                                <strong className="toast-title">{this.state.toastHeading}</strong>
                                <p>{this.state.toastMsg}</p>
                            </Toast.Body>
                            <button type="button"
                                onClick={this.closeToast}
                                className="close"
                                data-dismiss="toast"
                                aria-label="Close" />
                        </div>
                    </Toast>
                </div>
                <div className="qd-fullscreen fade show">
                    <div className="qd-fs_dialog">
                        <div className="qd-fs_content">
                            <div className="qd-fs_header">
                                <div className="header_content">
                                    <Image
                                        className="qd-header__brand-logo-default"
                                        src="logo"
                                    />
                                    <h4 className="header_title">
                                      Advanced Metrics Configuration
                                    </h4>
                                </div>
                                {this.state.loader &&
                                    <ProgressLoader />
                                }

                                <div className="actions">
                                    <BulkSchedule
                                        existingIntegrations={this.state.existingIntegrations}
                                        filterData={this.state.filterData}
                                        getMetricsMetadata={this.getMetricsMetadata}
                                        showToast={this.showToast}
                                        sleepInterval={this.state.sleepInterval}
                                    />

                                    {/* {this.bulkScheduleOption()} */}
                                    {/* <div className="line-divider"></div>
                                    <div className="btn-group scheduleMetric-btn-group">
                                        <button
                                            type="button"
                                            name="scheduleCalender"
                                            onClick={(e) => {
                                                this.handleScheduleMetricTabs(e)
                                            }}
                                            className={isScheduleCalenderActive ? "btn --is-active" : "btn"}
                                        >
                                            {isScheduleCalenderActive ?
                                                <i className="icon-check">
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M13.7489 4.25109C14.0837 4.58587 14.0837 5.12956 13.7489 5.46435L6.89253 12.3207C6.55775 12.6555 6.01406 12.6555 5.67928 12.3207L2.25109 8.89253C1.9163 8.55775 1.9163 8.01406 2.25109 7.67928C2.58587 7.34449 3.12956 7.34449 3.46435 7.67928L6.28724 10.4995L12.5383 4.25109C12.8731 3.9163 13.4168 3.9163 13.7516 4.25109H13.7489Z" fill="#212529" />
                                                    </svg>
                                                </i>
                                                : ''}
                                            <i>
                                                <svg xmlns="http://www.w3.org/2000/svg" className="d-block" width="18" height="18" viewBox="0 0 18 18">
                                                    <g id="icon_schedule" transform="translate(-846.5 -852.5)">
                                                        <g id="Group_4432" data-name="Group 4432" transform="translate(849.125 855.125)">
                                                            <path id="Path_2021" data-name="Path 2021" d="M13.821,9V4.821a1.289,1.289,0,0,0-1.286-1.286h-.643V2.25H10.607V3.536H5.464V2.25H4.179V3.536H3.536A1.289,1.289,0,0,0,2.25,4.821v9a1.289,1.289,0,0,0,1.286,1.286H8.357l-.321-1.286h-4.5V7.393h9V8.679Z" transform="translate(-2.25 -2.25)" fill="#484848" />
                                                            <path id="Path_2022" data-name="Path 2022" d="M11.893,9.321a3.214,3.214,0,1,0,3.214,3.214A3.215,3.215,0,0,0,11.893,9.321Zm1.061,4.725-1.382-1.382V10.607h.643V12.4L13.4,13.59Z" transform="translate(-2.25 -2.25)" fill="#484848" />
                                                        </g>
                                                        <rect id="Rectangle_628" data-name="Rectangle 628" width="18" height="18" transform="translate(846.5 852.5)" fill="none" />
                                                    </g>
                                                </svg>
                                            </i>
                                        </button>
                                        <button
                                            type="button"
                                            name="scheduleMetric"
                                            onClick={this.handleScheduleMetricTabs}
                                            className={isScheduleMetricActive ? "btn --is-active" : "btn"}
                                        >
                                            {isScheduleMetricActive ?
                                                <i className="icon-check">
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M13.7489 4.25109C14.0837 4.58587 14.0837 5.12956 13.7489 5.46435L6.89253 12.3207C6.55775 12.6555 6.01406 12.6555 5.67928 12.3207L2.25109 8.89253C1.9163 8.55775 1.9163 8.01406 2.25109 7.67928C2.58587 7.34449 3.12956 7.34449 3.46435 7.67928L6.28724 10.4995L12.5383 4.25109C12.8731 3.9163 13.4168 3.9163 13.7516 4.25109H13.7489Z" fill="#212529" />
                                                    </svg>
                                                </i>
                                                : ''}
                                            <i>
                                                <svg width="18" height="18" class="d-block" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M3.75 15.75C3.3375 15.75 2.98438 15.6031 2.69063 15.3094C2.39688 15.0156 2.25 14.6625 2.25 14.25V3.75C2.25 3.3375 2.39688 2.98438 2.69063 2.69063C2.98438 2.39688 3.3375 2.25 3.75 2.25H14.25C14.6625 2.25 15.0156 2.39688 15.3094 2.69063C15.6031 2.98438 15.75 3.3375 15.75 3.75V14.25C15.75 14.6625 15.6031 15.0156 15.3094 15.3094C15.0156 15.6031 14.6625 15.75 14.25 15.75H3.75ZM6 7.5C5.7875 7.5 5.60938 7.57188 5.46562 7.71562C5.32187 7.85938 5.25 8.0375 5.25 8.25V12C5.25 12.2125 5.32187 12.3906 5.46562 12.5344C5.60938 12.6781 5.7875 12.75 6 12.75C6.2125 12.75 6.39062 12.6781 6.53438 12.5344C6.67812 12.3906 6.75 12.2125 6.75 12V8.25C6.75 8.0375 6.67812 7.85938 6.53438 7.71562C6.39062 7.57188 6.2125 7.5 6 7.5ZM9 5.25C8.7875 5.25 8.60938 5.32187 8.46563 5.46562C8.32188 5.60938 8.25 5.7875 8.25 6V12C8.25 12.2125 8.32188 12.3906 8.46563 12.5344C8.60938 12.6781 8.7875 12.75 9 12.75C9.2125 12.75 9.39063 12.6781 9.53438 12.5344C9.67813 12.3906 9.75 12.2125 9.75 12V6C9.75 5.7875 9.67813 5.60938 9.53438 5.46562C9.39063 5.32187 9.2125 5.25 9 5.25ZM12 9.75C11.7875 9.75 11.6094 9.82188 11.4656 9.96563C11.3219 10.1094 11.25 10.2875 11.25 10.5V12C11.25 12.2125 11.3219 12.3906 11.4656 12.5344C11.6094 12.6781 11.7875 12.75 12 12.75C12.2125 12.75 12.3906 12.6781 12.5344 12.5344C12.6781 12.3906 12.75 12.2125 12.75 12V10.5C12.75 10.2875 12.6781 10.1094 12.5344 9.96563C12.3906 9.82188 12.2125 9.75 12 9.75Z" fill="#212529" />
                                                </svg>
                                            </i>
                                        </button>
                                    </div> */}


                                </div>
                                <button type="button" onClick={this.props.closeFullScreen} className="close" aria-label="Close" ref={this.rightScroll}>
                                    <span aria-hidden="true" />
                                    <span className="sr-only">Close</span>
                                </button>
                            </div>
                            <div className="qd-fs_body overflow-auto p-0" id='topCover'>
                                {this.state.showScheduleMetric ?
                                    <div className="tbl-metric-enable has-sticky-pagination">{/*add tbl-metric__sticky-header classname on vertical scrolling*/}
                                        <table className="table tbl-tree table-hover">
                                            <thead>
                                                <tr>
                                                    <th rowSpan="2" bgcolor="#FFFFFF">
                                                        <div className="tbl-heading">
                                                            <div className="tbl-heading__title">
                                                                <div className="caption">
                                                                    <span className="text-uppercase">Datasource</span>
                                                                </div>
                                                                <small>{this.state.integrations.length} Configured</small>
                                                                {/* <div className="action">
                                                                    <Dropdown>
                                                                        <Dropdown.Toggle variant="light" className="btn-sm">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="#AAAEB2"><path d="M0 0h24v24H0V0" fill="none" /><path d="M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6" /></svg>
                                                                            <span className="sr-only">Filter</span>
                                                                        </Dropdown.Toggle>
                                                                        <Dropdown.Menu>
                                                                            <Dropdown.Item href="#/action-3" className="py-1">
                                                                                Scheduled dataset
                                                                            </Dropdown.Item>
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>

                                                                </div> */}
                                                            </div>
                                                            <Select
                                                                options={this.state.integrations}
                                                                name="datasource"
                                                                classNamePrefix='form-control'
                                                                placeholder="Choose datasource"
                                                                value={this.state.selectedDatasource === null ? defaultDatasource : this.state.selectedDatasource}
                                                                // value = { defaultDatasource}

                                                                // value={this.state.selectedDatasource}
                                                                components={{ Control: customSelectDatasource }}
                                                                className="form-control--is-selected"
                                                                onChange=
                                                                {(e) => {
                                                                    this.setState({
                                                                        selectedDatasource: { "label": e.label, "value": e.value },
                                                                        enabledCount: '',
                                                                        currentPage: 1,
                                                                        totalItems: 0,
                                                                    })
                                                                    $(".tbl-metric-enable").addClass("qd-content-loading")
                                                                    this.getMetricsMetadata(e.value)
                                                                }}
                                                            />
                                                            <hr className="divider" />
                                                            <div className="qd-search-bar has-btn-close bordered" ref={this.letScroll}>{/* add has-btn-close for clearing search text */}
                                                                <div className="input-group">
                                                                    <div className="input-group-prepend">
                                                                        <button id="button-addon4" type="button" className="btn">
                                                                            <svg width="16" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path opacity="0.5" d="M14.8168 13.4542L11.9047 10.5525C11.6435 10.2921 11.2198 10.2921 10.9585 10.5525C10.6973 10.8128 10.6973 11.2349 10.9585 11.4953L13.8707 14.397C14.1319 14.6573 14.5556 14.6573 14.8168 14.397C15.0781 14.1366 15.0781 13.7145 14.8168 13.4542Z" fill="#A1A5B7" />
                                                                                <path d="M7.39346 12.6667C4.41988 12.6667 2.04102 10.2963 2.04102 7.33333C2.04102 4.37037 4.41988 2 7.39346 2C10.367 2 12.7459 4.37037 12.7459 7.33333C12.7459 10.2963 10.367 12.6667 7.39346 12.6667ZM7.39346 3.33333C5.07407 3.33333 3.37913 5.02222 3.37913 7.33333C3.37913 9.64447 5.07407 11.3333 7.39346 11.3333C9.71288 11.3333 11.4078 9.64447 11.4078 7.33333C11.4078 5.02222 9.71288 3.33333 7.39346 3.33333Z" fill="#A1A5B7" />
                                                                            </svg>
                                                                            {/* Spinner Loader */}
                                                                            {/* <i class="spinner-border spinner-border-xs spinner-border-gray"></i> */}
                                                                        </button>
                                                                    </div>
                                                                    <SearchField
                                                                        searchData = {this.searchData}
                                                                    />

                                                                </div>
                                                                {this.state.searchValue && <button className="btn btn-clear" title="Clear" onClick={this.clearSearch.bind(this)}><i className="icon-close"></i></button>}
                                                            </div>
                                                        </div>
                                                    </th>
                                                    {colMetricList.map((data) => {
                                                        return (<th colSpan={data.span} className={data.textClass}>
                                                            <font className={data.tableClass}>{data.metricName}</font>
                                                        </th>)
                                                    })}
                                                </tr>

                                                <tr>
                                                    {colMetricList.map((data) => {
                                                        return (data.subMetrics.map((data) => {
                                                            return (
                                                                <th className={data.tableClass}>
                                                                    <div className="tbl-heading">
                                                                        <h3><span>{data.metricName === "Unique Values" ? "Uniqueness" : data.metricName}</span></h3>
                                                                        <small>
                                                                            {data.content}
                                                                        </small>
                                                                        <p>
                                                                            <label>Enabled :</label>
                                                                            <ol className="breadcrumb">
                                                                                <li className="breadcrumb-item"><i><FontAwesomeIcon icon={faLayerGroup} /></i> {enabledCount !== "" ? enabledCount['datasets'] !== undefined && enabledCount['datasets'][data.metricName] === undefined ? 0 : enabledCount['datasets'][data.metricName]['enabled'] : ""}</li>
                                                                                <li className="breadcrumb-item"><i><FontAwesomeIcon icon={faTag} /></i> {enabledCount !== "" ? enabledCount['attributes'] !== undefined && enabledCount['attributes'][data.metricName] === undefined ? 0 : enabledCount['attributes'][data.metricName]['enabled'] : ""}</li>
                                                                            </ol>
                                                                        </p>
                                                                    </div>
                                                                </th>
                                                            )
                                                        }
                                                        ))
                                                    })}
                                                </tr>

                                            </thead>
                                            <tbody id="metaDataBody">
                                                {/* Start: First Node */}
                                                {metaDataList.map(
                                                    (data) => {
                                                        return (
                                                            <>
                                                                {data.integration_id !== undefined && enabledCount !== "" &&
                                                                    <tr className="tbl-sticky-row">
                                                                        <th bgcolor="#FFFFFF">
                                                                            <div className="tbl-tree__header">
                                                                                <div className="caption"><i><FontAwesomeIcon icon={faDatabase} /></i> {this.state.metaDataMapping[data.integration_id]}</div>
                                                                                <ol className="breadcrumb">
                                                                                    <li className="breadcrumb-item"><i><FontAwesomeIcon icon={faLayerGroup} /></i> {metaDataCount['datasets']}</li>
                                                                                    <li className="breadcrumb-item"><i><FontAwesomeIcon icon={faTag} /></i> {metaDataCount['attributes']}</li>
                                                                                </ol>
                                                                            </div>
                                                                        </th>

                                                                        {
                                                                            (data.metric_info).map((metricData, index) => {
                                                                                let integrationThresholdData = {
                                                                                    tenant_id: Number(localStorage.getItem('team_id')),
                                                                                    env_id: data.env_id,
                                                                                    integration_id: data.integration_id,
                                                                                    data_set_id: null,
                                                                                    attribute_id: null,
                                                                                    is_enable: metricData.is_enable,
                                                                                    metrics_id: metricData.metrics_id,
                                                                                    update_type: "integration_status",
                                                                                    metrics_name: metricData.metrics_name
                                                                                }
                                                                                let checked = false
                                                                                if (integrationThresholdData['is_enable'] === 1 || integrationThresholdData['is_enable'] === true) {
                                                                                    checked = true
                                                                                }
                                                                                integrationThresholdData['checked'] = checked
                                                                                return (
                                                                                    <IntegrationToggle
                                                                                        data={data}
                                                                                        filterData={this.props.filterData}
                                                                                        existingIntegrations={this.props.existingIntegrations}
                                                                                        metricData={metricData}
                                                                                        metaDataCount={metaDataCount}
                                                                                        enabledCount={enabledCount}
                                                                                        metaDataMapping={this.state.metaDataMapping}
                                                                                        showToast={this.showToast}
                                                                                        getMetricsMetadata={this.getMetricsMetadata}
                                                                                        activeMetrics={this.props.activeMetrics}
                                                                                        closeFullScreen={this.props.closeFullScreen}
                                                                                    />

                                                                                )
                                                                            })}
                                                                    </tr>}
                                                                {/* {data.dataset_list.length === 0 && this.state.searchValue !== "" ? <tr className='tbl-tree__parent tbl-tree--expanded datasetHighlight'><td colSpan={data.metric_info.length} className='text-center'>No data found</td></tr> : ""} */}
                                                                {data.dataset_list.length === 0 && this.state.searchValue!=="" ? <tr  className='tbl-tree__parent tbl-tree--expanded datasetHighlight'><td  className='text-center'><div className="alert_notree-search-match">
                                                                    <Image
                                                                        src="icon_exclamation_gray"
                                                                    />
                                                                    <p>No matches found for your search</p>
                                                                </div></td>
                                                                <td className="bg-light-info"><div className="divider-line"></div></td>

<td className="bg-light-orange"><div className="divider-line"></div></td>
<td className="bg-light-orange"><div className="divider-line"></div></td>

<td className="bg-light-success"><div className="divider-line"></div></td>

<td className="bg-light-royalblue"><div className="divider-line"></div></td>

<td className="bg-light-brown"><div className="divider-line"></div></td>

<td className="bg-light-warning"><div className="divider-line"></div></td>
<td className="bg-light-warning"><div className="divider-line"></div></td>
<td className="bg-light-warning"><div className="divider-line"></div></td>
<td className="bg-light-warning"><div className="divider-line"></div></td>
<td className="bg-light-warning"><div className="divider-line"></div></td>
<td className="bg-light-warning"><div className="divider-line"></div></td>
<td className="bg-light-warning"><div className="divider-line"></div></td>
<td className="bg-light-warning"><div className="divider-line"></div></td>
<td className="bg-light-warning"><div className="divider-line"></div></td>

<td className="bg-light-purple"><div className="divider-line"></div></td>
<td className="bg-light-purple"><div className="divider-line"></div></td>
<td className="bg-light-purple"><div className="divider-line"></div></td>

                                                                </tr>  : ""}
                                                                {
                                                                    data.dataset_list.slice(this.startItem() === 0 ? this.startItem() : this.startItem() - 1, this.endItem()).map((dataset, datasetIndex) => {
                                                                        // data.dataset_list.map((dataset, datasetIndex) => {
                                                                        let gmtTime = dataset['next_scheduled_time']
                                                                        let momentObj = new Date(gmtTime);
                                                                        let formattedTime = momentObj.toLocaleTimeString('en-US', { timeZone: 'GMT', hour12: true, hour: '2-digit', minute: '2-digit' });

                                                                        let nextScheduledTime = formattedTime
                                                                        nextScheduledTime = nextScheduledTime.replace(":", ".")
                                                                        let scheduledOn = { value: "Daily", label: "Daily" }
                                                                        let scheduledTimes = JSON.parse(dataset.scheduling_time)

                                                                        if (dataset["payload"] !== null && scheduledTimes !== null && scheduledTimes !== "null") {
                                                                            let days = Object.keys(scheduledTimes)
                                                                            let schedulingTime = scheduledTimes[days[0]]
                                                                            let times = timeRange.map((data) => {
                                                                                if (schedulingTime.includes(data.value)) {
                                                                                    return data.label
                                                                                }
                                                                                return null
                                                                            })
                                                                            times = times.filter((data) => data !== null)
                                                                            dataset['scheduledTimes'] = times

                                                                            dataset['scheduledDays'] = days
                                                                            scheduledOn = dataset['payload']['repeat_on']

                                                                            let customLable = "Weekly on "
                                                                            if (scheduledOn['value'] === "Custom") {
                                                                                days.map((day, index) => {
                                                                                    if (index === days.length - 1) {
                                                                                        customLable = customLable + day.slice(0, 3) + ". "
                                                                                    }
                                                                                    else {
                                                                                        customLable = customLable + day.slice(0, 3) + ", "
                                                                                    }
                                                                                    return null
                                                                                }
                                                                                )
                                                                                scheduledOn['value'] = customLable
                                                                            }
                                                                        }
                                                                        else {
                                                                            dataset['scheduledTimes'] = [formattedTime]
                                                                            dataset['scheduledDays'] = []
                                                                        }

                                                                        let defaultScan = false
                                                                        if (dataset['payload'] === null || dataset['scheduledDays'].length === 0) {
                                                                            defaultScan = true
                                                                        }
                                                                        let addOnClass = ''
                                                                        return (
                                                                            <>
                                                                                <tr className={"tbl-tree__parent tbl-tree--expanded datasetHighlight highlight" + dataset.dataset_id}> {/* add class --is-expanded for arrow down */}
                                                                                    <td bgcolor="#FFFFFF">
                                                                                        <div className="tbl-tree__node">
                                                                                            <div className="tbl-tree__node-label">
                                                                                                <i className="toggle-icon-wrap">
                                                                                                    <span className="toggle-icon"
                                                                                                        onClick={(e) => {
                                                                                                            let className = ""
                                                                                                            let expandClass = ".highlight" + dataset.dataset_id
                                                                                                            let buttonClass = '.' + dataset.dataset_id + "_expand"
                                                                                                            if (dataset['collapse'] === "false") {
                                                                                                                className = "." + dataset.dataset_id + "_nestedDataset"
                                                                                                                $(className).addClass('d-none')
                                                                                                                dataset['collapse'] = "true"

                                                                                                                $(buttonClass).addClass('d-none')
                                                                                                                $(expandClass).removeClass(' tbl-tree--expanded')

                                                                                                            }
                                                                                                            else {
                                                                                                                className = "." + dataset.dataset_id + "_nestedDataset"
                                                                                                                $(className).removeClass('d-none')
                                                                                                                dataset['collapse'] = "false"

                                                                                                                addOnClass = '.' + dataset.dataset_id + "_addOnClass"
                                                                                                                $(addOnClass).addClass('d-none')

                                                                                                                $(buttonClass).removeClass('d-none')
                                                                                                                $(expandClass).addClass(' tbl-tree--expanded')
                                                                                                            }
                                                                                                            this.adjustHeight()
                                                                                                        }}
                                                                                                    />
                                                                                                    {/* <span className="spinner-border spinner-border-xs spinner-border-gray"></span> */}
                                                                                                </i>
                                                                                                <i className="tbl-tree__node-icon"><FontAwesomeIcon icon={faLayerGroup} /></i>
                                                                                                <div className="tbl-tree__node-text">
                                                                                                {this.state.searchValue.length > 0 && dataset['dataset_name'].toLowerCase().includes(this.state.searchValue.toLowerCase()) 
                                                                                                        ?
                                                                                                        <>
                                                                                                            <span>{dataset['dataset_name'].split(new RegExp(this.state.searchValue, "i"))[0]}</span>
                                                                                                            <strong className="tree-search-text-highlight">{dataset['dataset_name'].match(new RegExp(this.state.searchValue, "i"))[0]}</strong>
                                                                                                            <span>{dataset['dataset_name'].split(new RegExp(this.state.searchValue, "i"))[1]}</span>
                                                                                                        </>
                                                                                                        :
                                                                                                        <>
                                                                                                            {
                                                                                                                dataset['dataset_name'].length <= 16 ? <span className="portlet-table-value">{dataset['dataset_name']}</span>
                                                                                                                    :
                                                                                                                    <RcTooltip
                                                                                                                        placement="top"
                                                                                                                        overlay={renderTooltipSummary(dataset['dataset_name'])}
                                                                                                                        arrowContent={
                                                                                                                            <div
                                                                                                                                className="rc-tooltip-arrow-inner">
                                                                                                                            </div>}>
                                                                                                                        <span className="portlet-table-value">{dataset['dataset_name']  // !== null ? dataset['dataset_name'] : "NA"
                                                                                                                        }</span>
                                                                                                                    </RcTooltip>
                                                                                                            }
                                                                                                        </>
                                                                                                    }
                                                                                                    {/* <span>{dataset['dataset_name']}</span> */}
                                                                                                </div>
                                                                                                {/* <span className="dot-separator"></span> */}
                                                                                                {/* {nextScheduledTime !== null && nextScheduledTime !== undefined && */}
                                                                                                    <OverlayTrigger
                                                                                                        rootCloseEvent="click"
                                                                                                        rootClose
                                                                                                        trigger="click"
                                                                                                        placement="right"
                                                                                                        transition={false}
                                                                                                        onToggle={(isOpen) => {
                                                                                                            this.handleSchedulePopoverToggle(isOpen, dataset, data.integration_id);
                                                                                                        }}
                                                                                                        overlay={(overlayProps) =>
                                                                                                            this.scheduleTimePopover(dataset, scheduledOn, nextScheduledTime, defaultScan, overlayProps)
                                                                                                        }
                                                                                                    >
                                                                                                        <div className="metric-scheduled-time text-royalblue" onClick={this.bodyscrollhide}>
                                                                                                            {/* <div className="metric-scheduled-time__col">
                                                                                                                <div className="metric-scheduled-time__col">
                                                                                                                    {defaultScan === true ?
                                                                                                                        <>
                                                                                                                            <i>
                                                                                                                                <Timer className="tw-w-3.5 tw-h-3.5 !tw-block" />                                                                                                                               
                                                                                                                            </i>
                                                                                                                            {this.state.sleepInterval + "m once"}
                                                                                                                        </>
                                                                                                                        :
                                                                                                                        <>
                                                                                                                            <i>
                                                                                                                                <FontAwesomeIcon
                                                                                                                                    icon={faClock}
                                                                                                                                />
                                                                                                                            </i>
                                                                                                                            {nextScheduledTime}
                                                                                                                        </>
                                                                                                                    }
                                                                                                                </div>
                                                                                                            </div> */}
                                                                                                            {defaultScan === true ? "" :
                                                                                                                <div className="metric-scheduled-time__col">
                                                                                                                    <i>
                                                                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24">
                                                                                                                            <g id="icon_repeat" transform="translate(-881 -905)">
                                                                                                                                <path id="icon_repeat-2" data-name="icon_repeat" d="M6.556,18.088l.8.8a.862.862,0,0,1,.271.659.992.992,0,0,1-.271.659.959.959,0,0,1-.671.294.876.876,0,0,1-.671-.271L3.592,17.806a.826.826,0,0,1-.2-.306,1.088,1.088,0,0,1,0-.706.826.826,0,0,1,.2-.306l2.423-2.423a.876.876,0,0,1,.671-.27.959.959,0,0,1,.671.294.992.992,0,0,1,.271.659.862.862,0,0,1-.271.659l-.8.8h9.552V13.382a.941.941,0,1,1,1.882,0v2.823a1.888,1.888,0,0,1-1.882,1.882ZM16.25,6.794H6.7V9.618a.948.948,0,0,1-1.612.671.911.911,0,0,1-.271-.671V6.794A1.888,1.888,0,0,1,6.7,4.912H16.25l-.8-.8a.863.863,0,0,1-.271-.659.993.993,0,0,1,.271-.659.96.96,0,0,1,.671-.294.876.876,0,0,1,.671.271l2.423,2.423a.827.827,0,0,1,.2.306,1.089,1.089,0,0,1,0,.706.826.826,0,0,1-.2.306L16.791,8.935a.876.876,0,0,1-.671.271.96.96,0,0,1-.671-.294.993.993,0,0,1-.271-.659.863.863,0,0,1,.271-.659Z" transform="translate(881.667 905.5)" fill="currentColor" />
                                                                                                                                <rect id="Rectangle_632" data-name="Rectangle 632" width="24" height="24" transform="translate(881 905)" fill="none" />
                                                                                                                            </g>
                                                                                                                        </svg>
                                                                                                                    </i>
                                                                                                                </div>
                                                                                                            }
                                                                                                        </div>
                                                                                                    </OverlayTrigger>
                                                                                                {nextScheduledTime !== null && nextScheduledTime !== undefined &&
                                                                                                    <div 
                                                                                                        className="metric-scheduled-time" 
                                                                                                        style={{ 
                                                                                                            cursor: 'default',
                                                                                                            color: defaultScan === true
                                                                                                                ? (this.state.globalScanOption === 'auto' ? '#1f8a4c' : '#334DB7')
                                                                                                                : '#DC6803'
                                                                                                        }}
                                                                                                    >
                                                                                                        <div className="metric-scheduled-time__col">
                                                                                                            <i>
                                                                                                                {defaultScan === true
                                                                                                                    ? (this.state.globalScanOption === 'auto' ? <Sparkles className="tw-w-3 tw-h-3 !tw-block" /> : <ClockCheck className="tw-w-3 tw-h-3 !tw-block" />)
                                                                                                                    : <CalendarClock className="tw-w-3 tw-h-3 !tw-block" />
                                                                                                                }
                                                                                                            </i>
                                                                                                            {defaultScan === true
                                                                                                                ? (this.state.globalScanOption === 'auto' ? 'Auto' : 'Every ' + this.state.sleepInterval + ' min')
                                                                                                                : ('Daily ' + nextScheduledTime)
                                                                                                            }
                                                                                                        </div>
                                                                                                        <OverlayTrigger
                                                                                                            trigger={["hover", "focus"]}
                                                                                                            placement="right"
                                                                                                            transition={false}
                                                                                                            onToggle={(isOpen) => {
                                                                                                                this.handleSchedulePopoverToggle(isOpen, dataset, data.integration_id);
                                                                                                            }}
                                                                                                            overlay={(overlayProps) =>
                                                                                                                this.scheduleTimePopover(dataset, scheduledOn, nextScheduledTime, defaultScan, overlayProps)
                                                                                                            }
                                                                                                        >
                                                                                                            <span className="tw-cursor-pointer tw-text-gray-400 hover:tw-text-gray-600 tw-ml-[2px] tw-inline-flex tw-items-center">
                                                                                                                <CircleHelp className="tw-w-3 tw-h-3" />
                                                                                                            </span>
                                                                                                        </OverlayTrigger>
                                                                                                    </div>
                                                                                                }
     
                                                                                            </div>
                                                                                        </div>
                                                                                    </td>


                                                                                            <DatasetToggle
                                                                                                data={data}
                                                                                                dataset={dataset}
                                                                                                filterData={this.props.filterData}
                                                                                                existingIntegrations={this.props.existingIntegrations}
                                                                                                // attribute={attribute}
                                                                                                enabledCount={enabledCount}
                                                                                                metaDataMapping={this.state.metaDataMapping}
                                                                                                // datasetThresholdData={datasetThresholdData}
                                                                                                metaDataCount={metaDataCount}
                                                                                                //-- datasetMetric={datasetMetric}
                                                                                                nextScheduledTime={moment(dataset['next_scheduled_time'])}
                                                                                                // updateThresholdData={this.updateThresholdData}
                                                                                                getMetricsMetadata={this.getMetricsMetadata}
                                                                                                showToast={this.showToast}
                                                                                                sleepInterval={this.state.sleepInterval}
                                                                                                activeMetrics={this.props.activeMetrics}
                                                                                                closeFullScreen={this.props.closeFullScreen}
                                                                                                progressLoader= {this.progressLoader} 

                                                                                            />


                                                                                    {/* {dataset.metric_info.map((datasetMetric, index) => {


                                                                                            <DatasetToggle
                                                                                                data={data}
                                                                                                dataset={dataset}
                                                                                                filterData={this.props.filterData['datasets']}
                                                                                                // attribute={attribute}
                                                                                                enabledCount={enabledCount}
                                                                                                metaDataMapping={this.state.metaDataMapping}
                                                                                                // datasetThresholdData={datasetThresholdData}
                                                                                                metaDataCount={metaDataCount}
                                                                                                datasetMetric={datasetMetric}
                                                                                                nextScheduledTime={moment(dataset['next_scheduled_time'])}
                                                                                                // updateThresholdData={this.updateThresholdData}
                                                                                                getMetricsMetadata={this.getMetricsMetadata}
                                                                                                showToast={this.showToast}
                                                                                                sleepInterval={this.state.sleepInterval}
                                                                                                activeMetrics={this.props.activeMetrics}
                                                                                                closeFullScreen={this.props.closeFullScreen}
                                                                                            />
                                                                                        )
                                                                                    })} */}
                                                                                </tr>
                                                                                <tr className="tbl-tree__nested">
                                                                                    <td colSpan="19">
                                                                                        <table class={dataset.dataset_id + "_nestedAttributes table table-hover"}>
                                                                                            <tbody id={dataset.dataset_id + "_nestedAttributes"}>
                                                                                                {
                                                                                                    dataset.attribute_list.slice(0, dataset.attribute_list.length > 3 && parseInt(showMoreDatasetId) === parseInt(dataset.dataset_id) && this.state.showMoreStatus === false ? dataset.attribute_list.length : dataset.attribute_list.length > 3 ? 3 : dataset.attribute_list.length).map((attribute, index) => {
                                                                                                        // dataset.attribute_list.map((attribute, index) => {
                                                                                                        if (index > 2) {
                                                                                                            addOnClass = (dataset.dataset_id) + "_addOnClass"
                                                                                                        }
                                                                                                        dataset['collapse'] = "false"
                                                                                                        let normalizeAttributeNames = normalizeAttributeName(attribute.attribute_name)
                                                                                                        const getLabelFromEnvId = (env_id) => {
                                                                                                            const match = this.state.environments?.find(env => env.value === env_id);
                                                                                                            return match ? match.label : '';
                                                                                                            };
                                                                                                    
                                                                                                        const getLabelFromIntegration = (integration_id) => {
                                                                                                            const match = this.state.integrations?.find(integ => integ.value === integration_id);
                                                                                                            return match ? match.label : '';
                                                                                                            };

                                                                                                        return (
                                                                                                            <>
                                                                                                                <tr class={(dataset.dataset_id) + "_nestedDataset " + addOnClass + " attributeHighlight highlight" + normalizeAttributeNames}>
                                                                                                                    {/* <td colSpan="19"> */}
                                                                                                                    <td bgcolor="#FFFFFF">
                                                                                                                        <div className="tbl-tree__node">
                                                                                                                            <div className="tbl-tree__node-label">
                                                                                                                                <i className="tbl-tree__node-icon"><FontAwesomeIcon icon={faTag} /></i>
                                                                                                                                <div className="tbl-tree__node-text">
                                                                                                                                {this.state.searchValue.length > 0 && normalizeAttributeNames.toLowerCase().includes(this.state.searchValue.toLowerCase())
                                                                                                                                        ?
                                                                                                                                        <>
                                                                                                                                            <span>{normalizeAttributeNames.split(new RegExp(this.state.searchValue, "i"))[0]}</span>
                                                                                                                                            <strong className="tree-search-text-highlight">{normalizeAttributeNames.match(new RegExp(this.state.searchValue, "i"))[0]}</strong>
                                                                                                                                            <span>{normalizeAttributeNames.split(new RegExp(this.state.searchValue, "i"))[1]}</span>
                                                                                                                                        </>
                                                                                                                                        :

                                                                                                                                        <>
                                                                                                                                            {attribute['attribute_name'].length <= 19 ? <span className="portlet-table-value">{normalizeAttributeNames}</span>
                                                                                                                                                :
                                                                                                                                                <RcTooltip
                                                                                                                                                    placement="top"
                                                                                                                                                    overlay={renderTooltipSummary(normalizeAttributeNames)}
                                                                                                                                                    arrowContent={
                                                                                                                                                        <div
                                                                                                                                                            className="rc-tooltip-arrow-inner">
                                                                                                                                                        </div>}>
                                                                                                                                                    <span className="portlet-table-value">{normalizeAttributeNames}</span>
                                                                                                                                                </RcTooltip>}
                                                                                                                                        </>
                                                                                                                                        // <span>{attribute.attribute_name}</span>
                                                                                                                                    }
                                                                                                                                </div>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                    </td>

                                                                                                                    {attribute.metric_info.map((metricData) => {
                                                                                                                        let attributeData = {
                                                                                                                            envId: data.env_id,
                                                                                                                            integrationId: data.integration_id,
                                                                                                                            datasetId: dataset.dataset_id,
                                                                                                                            attributeId: attribute.attribute_id,
                                                                                                                            envName: getLabelFromEnvId(data.env_id),
                                                                                                                            integrationName: getLabelFromIntegration(data.integration_id),
                                                                                                                            datasetName: dataset['dataset_name'],
                                                                                                                            attributeName: normalizeAttributeName(attribute.attribute_name),
                                                                                                                        }

                                                                                                                        return (
                                                                                                                            <>
                                                                                                                                <td id={metricData['metrics_id'] === undefined ? 'row_' + metricData['dummyId'] + "_" + attribute.attribute_id : 'row_' + metricData['metrics_id'] + "_" + attribute.attribute_id} className={metricClassMapping[metricData['metrics_name']]['tableClass']}>
                                                                                                                                    {metricData['is_enable'] === "NA" ? <Image src="icon_switch" className="cursor-not-allowed" /> :
                                                                                                                                        <AttributeToggle
                                                                                                                                            className={metricClassMapping[metricData['metrics_name']]['tableClass']}
                                                                                                                                            attributeData={attributeData}
                                                                                                                                            metricData={metricData}
                                                                                                                                            // updateThresholdData={this.updateThresholdData}
                                                                                                                                            postToggleAction={this.postToggleAction}
                                                                                                                                            showToast={this.showToast}
                                                                                                                                            getMetricsMetadata={this.getMetricsMetadata}
                                                                                                                                            activeMetrics={this.props.activeMetrics}
                                                                                                                                            closeFullScreen={this.props.closeFullScreen}
                                                                                                                                            progressLoader= {this.progressLoader}
                                                                                                                                        />
                                                                                                                                        }
                                                                                                                                </td>
                                                                                                                            </>
                                                                                                                        )
                                                                                                                    })}
                                                                                                                    {/* </td> */}
                                                                                                                </tr>

                                                                                                                {/* </tr> */}
                                                                                                                {index === (dataset.attribute_list.length >= 3 && parseInt(showMoreDatasetId) === parseInt(dataset.dataset_id) ? dataset.attribute_list.length : dataset.attribute_list.length > 3 ? 3 : dataset.attribute_list.length) - 1 && dataset.attribute_list.length > 3 &&
                                                                                                                    <>
                                                                                                                        <tr>
                                                                                                                            <td bgcolor="#FFFFFF">
                                                                                                                                <div className="tbl-tree__footer">
                                                                                                                                    {/* <span className="text-muted mr-2">1-20 of 200</span> */}
                                                                                                                                    {/* <span className="text-muted mr-2">1-20 of 200</span> */}
                                                                                                                                    <button
                                                                                                                                        type="button"
                                                                                                                                        id="id-addOn True"
                                                                                                                                        // id={dataset.dataset_id}
                                                                                                                                        // value = {this.state.showMore}
                                                                                                                                        className={dataset.dataset_id + "_expand false btn tbl-tree__expand-btn mr-1"}
                                                                                                                                        onClick={(e) => {

                                                                                                                                            // let buttonClass = '.' + dataset.dataset_id + "_expand"
                                                                                                                                            addOnClass = '.' + dataset.dataset_id + "_addOnClass"
                                                                                                                                            // const currentText = $(buttonClass).text();

                                                                                                                                            if(dataset.dataset_id===showMoreDatasetId){

                                                                                                                                                if (this.state.showMoreStatus) {
                                                                                                                                                    this.setSelectedDataset(dataset.dataset_id, false,dataset.dataset_id)
                                                                                                                                                } else {
                                                                                                                                                    this.setSelectedDataset("",true,dataset.dataset_id)
                                                                                                                                                }

                                                                                                                                            }else {
                                                                                                                                                this.setSelectedDataset(dataset.dataset_id, false,dataset.dataset_id)
                                                                                                                                            }



                                                                                                                                            // if (this.state.showMoreStatus) {
                                                                                                                                            //     this.setSelectedDataset(dataset.dataset_id, false)
                                                                                                                                            // } else {
                                                                                                                                            //     this.setSelectedDataset("", dataset.dataset_id===showMoreDatasetId ? true : false)
                                                                                                                                            // }
                                                                                                                                            // if (currentText === 'show more attributes') {
                                                                                                                                            //     // $(buttonClass).text("show less attributes");
                                                                                                                                            //     this.setSelectedDataset(dataset.dataset_id,true)
                                                                                                                                            //     // $(addOnClass).removeClass('d-none')
                                                                                                                                            // }
                                                                                                                                            // else {
                                                                                                                                            //     this.setSelectedDataset(dataset.dataset_id,false)
                                                                                                                                            //     // $(buttonClass).text("show more attributes");
                                                                                                                                            //     // $(addOnClass).addClass('d-none')
                                                                                                                                            // }
                                                                                                                                        }}
                                                                                                                                    >
                                                                                                                                        {this.state.showMoreStatus === true && parseInt(showMoreDatasetId) === parseInt(dataset.dataset_id) ?
                                                                                                                                            <><i id={"showmore_"+dataset.dataset_id}>
                                                                                                                                                <FontAwesomeIcon icon={faAngleDoubleDown} />
                                                                                                                                            </i>
                                                                                                                                            <span id={"spinner_"+dataset.dataset_id} className="d-none spinner-border spinner-border-xs spinner-border-gray align-middle mr-1"></span>
                                                                                                                                            <span id={"more_"+dataset.dataset_id}>{"show more attributes"}</span></>
                                                                                                                                            : this.state.showMoreStatus === false && parseInt(showMoreDatasetId) === parseInt(dataset.dataset_id) ?
                                                                                                                                                <><i id={"showmore_"+dataset.dataset_id}>
                                                                                                                                                    <FontAwesomeIcon icon={faAngleDoubleUp} />
                                                                                                                                                </i>
                                                                                                                                                <span id={"spinner_"+dataset.dataset_id} className="d-none spinner-border spinner-border-xs spinner-border-gray align-middle mr-1"></span>
                                                                                                                                                <span id={"more_"+dataset.dataset_id}>{"show less attributes"}</span></> :
                                                                                                                                                <><i id={"showmore_"+dataset.dataset_id}>
                                                                                                                                                    <FontAwesomeIcon icon={faAngleDoubleDown} />
                                                                                                                                                </i>
                                                                                                                                                <span id={"spinner_"+dataset.dataset_id} className="d-none spinner-border spinner-border-xs spinner-border-gray align-middle mr-1"></span>
                                                                                                                                                <span id={"more_"+dataset.dataset_id}>{"show more attributes"}</span></>

                                                                                                                                        }
                                                                                                                                        {/* {"Show 20 more attributes"} */}
                                                                                                                                    </button>
                                                                                                                                </div>
                                                                                                                            </td>

                                                                                                                            <td className="bg-light-info"></td>

                                                                                                                            <td className="bg-light-orange"></td>
                                                                                                                            <td className="bg-light-orange"></td>

                                                                                                                            <td className="bg-light-success"></td>

                                                                                                                            <td className="bg-light-royalblue"></td>

                                                                                                                            <td className="bg-light-brown"></td>

                                                                                                                            <td className="bg-light-warning"></td>
                                                                                                                            <td className="bg-light-warning"></td>
                                                                                                                            <td className="bg-light-warning"></td>
                                                                                                                            <td className="bg-light-warning"></td>
                                                                                                                            <td className="bg-light-warning"></td>
                                                                                                                            <td className="bg-light-warning"></td>
                                                                                                                            <td className="bg-light-warning"></td>
                                                                                                                            <td className="bg-light-warning"></td>
                                                                                                                            <td className="bg-light-warning"></td>

                                                                                                                            <td className="bg-light-purple"></td>
                                                                                                                            <td className="bg-light-purple"></td>
                                                                                                                            <td className="bg-light-purple"></td>
                                                                                                                        </tr>
                                                                                                                        {
                                                                                                                        data.dataset_list.length === 0 ? <tr  className=''><td  className='text-center'></td></tr>  : ""
                                                                                                                        }
                                                                                                                    </>
                                                                                                                }

                                                                                                                {/* {index === dataset.attribute_list.length - 1 && datasetIndex === data.dataset_list.length - 1 &&
                                                                                                                    adjustHeight.map(() => {
                                                                                                                        // if (innerHeight !== 0 && outterHeight !== 0
                                                                                                                        //     //  Dynamic Heght Adjustment needs to be handled
                                                                                                                        //     //  || innerHeight > outterHeight || innerHeight < outterHeight
                                                                                                                        // )
                                                                                                                        return (
                                                                                                                            <>
                                                                                                                                <tr>
                                                                                                                                    <td className="bg-white"></td>

                                                                                                                                    <td className="bg-light-info"></td>

                                                                                                                                    <td className="bg-light-orange"></td>
                                                                                                                                    <td className="bg-light-orange"></td>

                                                                                                                                    <td className="bg-light-success"></td>

                                                                                                                                    <td className="bg-light-royalblue"></td>

                                                                                                                                    <td className="bg-light-brown"></td>

                                                                                                                                    <td className="bg-light-warning"></td>
                                                                                                                                    <td className="bg-light-warning"></td>
                                                                                                                                    <td className="bg-light-warning"></td>
                                                                                                                                    <td className="bg-light-warning"></td>
                                                                                                                                    <td className="bg-light-warning"></td>
                                                                                                                                    <td className="bg-light-warning"></td>
                                                                                                                                    <td className="bg-light-warning"></td>
                                                                                                                                    <td className="bg-light-warning"></td>
                                                                                                                                    <td className="bg-light-warning"></td>

                                                                                                                                    <td className="bg-light-purple"></td>
                                                                                                                                    <td className="bg-light-purple"></td>
                                                                                                                                    <td className="bg-light-purple"></td>
                                                                                                                                </tr>
                                                                                                                            </>
                                                                                                                        )
                                                                                                                    })} */}
                                                                                                            </>
                                                                                                        )
                                                                                                    })
                                                                                                }
                                                                                                <tr className="dataset-level-divider">
                                                                                                    <td className="bg-white"><div className="divider-line"></div></td>
                                                                                                    <td className="bg-light-info"><div className="divider-line"></div></td>
                                                                                                    <td className="bg-light-orange"><div className="divider-line"></div></td>
                                                                                                    <td className="bg-light-orange"><div className="divider-line"></div></td>
                                                                                                    <td className="bg-light-success"><div className="divider-line"></div></td>
                                                                                                    <td className="bg-light-royalblue"><div className="divider-line"></div></td>
                                                                                                    <td className="bg-light-brown"><div className="divider-line"></div></td>
                                                                                                    <td className="bg-light-warning"><div className="divider-line"></div></td>
                                                                                                    <td className="bg-light-warning"><div className="divider-line"></div></td>
                                                                                                    <td className="bg-light-warning"><div className="divider-line"></div></td>
                                                                                                    <td className="bg-light-warning"><div className="divider-line"></div></td>
                                                                                                    <td className="bg-light-warning"><div className="divider-line"></div></td>
                                                                                                    <td className="bg-light-warning"><div className="divider-line"></div></td>
                                                                                                    <td className="bg-light-warning"><div className="divider-line"></div></td>
                                                                                                    <td className="bg-light-warning"><div className="divider-line"></div></td>
                                                                                                    <td className="bg-light-warning"><div className="divider-line"></div></td>
                                                                                                    <td className="bg-light-purple"><div className="divider-line"></div></td>
                                                                                                    <td className="bg-light-purple"><div className="divider-line"></div></td>
                                                                                                    <td className="bg-light-purple"><div className="divider-line"></div></td>
                                                                                                </tr>
                                                                                            </tbody>
                                                                                        </table>
                                                                                    </td>
                                                                                </tr>
                                                                            </>

                                                                        )
                                                                    })
                                                                }
                                                                <tr class="emptyrow">
                                                                <td className="bg-white"><div className="divider-line"></div></td>

<td className="bg-light-info"><div className="divider-line"></div></td>

<td className="bg-light-orange"><div className="divider-line"></div></td>
<td className="bg-light-orange"><div className="divider-line"></div></td>

<td className="bg-light-success"><div className="divider-line"></div></td>

<td className="bg-light-royalblue"><div className="divider-line"></div></td>

<td className="bg-light-brown"><div className="divider-line"></div></td>

<td className="bg-light-warning"><div className="divider-line"></div></td>
<td className="bg-light-warning"><div className="divider-line"></div></td>
<td className="bg-light-warning"><div className="divider-line"></div></td>
<td className="bg-light-warning"><div className="divider-line"></div></td>
<td className="bg-light-warning"><div className="divider-line"></div></td>
<td className="bg-light-warning"><div className="divider-line"></div></td>
<td className="bg-light-warning"><div className="divider-line"></div></td>
<td className="bg-light-warning"><div className="divider-line"></div></td>
<td className="bg-light-warning"><div className="divider-line"></div></td>

<td className="bg-light-purple"><div className="divider-line"></div></td>
<td className="bg-light-purple"><div className="divider-line"></div></td>
<td className="bg-light-purple"><div className="divider-line"></div></td>

                                                                </tr>
                                                            </>
                                                        )
                                                    }
                                                )
                                                }
                                            </tbody>
                                        </table>

                                        <div className="react-bootstrap-table__footer tbl-metric-enable__footer">
                                            <div className="tbl-metric-enable__footer-container">
                                                <div className="tbl-metric-enable__footer-left">
                                                {/* Pagination */}
                                                {this.adjustHeight()}
                                                {this.state.totalItems > 0 ?  (

                                                    <ul className="pagination react-bootstrap-table-page-btns-ul">
                                                    {/* Previous button */}
                                                                <li
                                                                    className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}
                                                                    title="previous page"
                                                                    onClick={() => this.changePage(currentPage - 1)}
                                                                >
                                                                    <a href="#!" className="page-link">&lt;</a>
                                                                </li>

                                                    {/* Show only 7 page numbers */}
                                                    {(() => {
                                                        const maxPagesToShow = 7;
                                                        let startPage = Math.max(currentPage - Math.floor(maxPagesToShow / 2), 1);
                                                        let endPage = startPage + maxPagesToShow - 1;

                                                        // Ensure the endPage doesn't exceed totalPages
                                                        if (endPage > totalPages) {
                                                        endPage = totalPages;
                                                        startPage = Math.max(endPage - maxPagesToShow + 1, 1);
                                                        }

                                                        const pageNumbers = [];
                                                        for (let i = startPage; i <= endPage; i++) {
                                                        pageNumbers.push(i);
                                                        }

                                                        return pageNumbers.map((pageNum) => (
                                                        <li
                                                            key={pageNum}
                                                            className={`page-item ${currentPage === pageNum ? 'active' : ''}`}
                                                            title={pageNum}
                                                            onClick={() => this.changePage(pageNum)}
                                                        >
                                                            <a href="#!" className="page-link">{pageNum}</a>
                                                        </li>
                                                        ));
                                                    })()}

                                                    {/* Next button */}
                                                    <li
                                                        className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}
                                                        title="next page"
                                                        onClick={() => this.changePage(currentPage + 1)}
                                                    >
                                                        <a href="#!" className="page-link">&gt;</a>
                                                    </li>
                                                    </ul>
                                                ) : (
                                                    ""
                                                )}
                                                </div>

                                                <div className="tbl-metric-enable__footer-right">
                                                {this.state.totalItems > 0 ? (
                                                    <span className="react-table__info">
                                                    Showing <b>{this.startItem()}</b> to <b>{this.endItem()}</b> of <b>{this.state.totalItems}</b> results
                                                    </span>
                                                ) : (
                                                    ""
                                                )}
                                                </div>
                                            </div>
                                            </div>

                                        <div className="tbl-scroll-btns">
                                            <div
                                                className="left-scroll-btn"
                                                onClick={(e) => {
                                                this.scrollToLeft()
                                            }}>
                                                <i>
                                                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M14.71 6.71c-.39-.39-1.02-.39-1.41 0L8.71 11.3c-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L10.83 12l3.88-3.88c.39-.39.38-1.03 0-1.41z" /></svg>
                                                </i>
                                            </div>
                                            <div
                                                className="right-scroll-btn"
                                                onClick={(e) => {
                                                            this.scrollToRight()
                                                        }}
                                                >
                                                <i>
                                                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M9.29 6.71c-.39.39-.39 1.02 0 1.41L13.17 12l-3.88 3.88c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41L10.7 6.7c-.38-.38-1.02-.38-1.41.01z" /></svg>
                                                </i>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div className="d-flex w-100 h-100 p-5">
                                        <div className="row w-100 pt-5">
                                            <div className="col-6 offset-3">
                                                <div className="card text-center">
                                                    <div className="card-body px-5">
                                                        <i className="d-block my-2">
                                                            <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48" fill="#5f6368"><path d="M596.32-180q-125.69 0-212.93-87.24-87.23-87.23-87.23-212.93 0-124.75 87.23-212.29Q470.63-780 596.32-780q124.76 0 212.29 87.54 87.54 87.54 87.54 212.29 0 125.7-87.54 212.93Q721.08-180 596.32-180Zm29.83-311.77v-112.08q0-12.75-8.63-21.37-8.62-8.63-21.38-8.63t-21.37 8.63q-8.62 8.62-8.62 21.37v122.16q0 7.06 2.93 13.68 2.92 6.62 8.02 11.75l92.82 93.18q8.93 9.31 21.2 9.31 12.26 0 21.57-9.31 9.31-9.3 9.31-21.38 0-12.08-9.31-21.39l-86.54-85.92ZM133.85-610q-12.75 0-21.38-8.63-8.62-8.63-8.62-21.38 0-12.76 8.62-21.37 8.63-8.62 21.38-8.62h92.31q12.75 0 21.37 8.63 8.63 8.63 8.63 21.38 0 12.76-8.63 21.37-8.62 8.62-21.37 8.62h-92.31Zm-40 160q-12.75 0-21.38-8.63-8.62-8.63-8.62-21.38 0-12.76 8.62-21.37Q81.1-510 93.85-510h132.31q12.75 0 21.37 8.63 8.63 8.63 8.63 21.38 0 12.76-8.63 21.37-8.62 8.62-21.37 8.62H93.85Zm40 160q-12.75 0-21.38-8.63-8.62-8.63-8.62-21.38 0-12.76 8.62-21.37 8.63-8.62 21.38-8.62h92.31q12.75 0 21.37 8.63 8.63 8.63 8.63 21.38 0 12.76-8.63 21.37-8.62 8.62-21.37 8.62h-92.31Z" /></svg>
                                                        </i>
                                                        <h4 className="h5 text-dark mb-3">Coming Soon</h4>
                                                        <p className="text-muted">We’re working hard to bring you something amazing. <br />Stay tuned for updates!</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div >
            </>
        )
    }
}
